// This file is auto-generated by @hey-api/openapi-ts

import {
  type DefaultError,
  type InfiniteData,
  infiniteQueryOptions,
  queryOptions,
  type UseMutationOptions
} from '@tanstack/react-query'
import type { AxiosError } from 'axios'

import { client } from '../client.gen'
import {
  apiAgentsAssigneesCreate,
  apiAgentsAssigneesDestroy,
  apiAgentsAssigneesRetrieve,
  apiAgentsAutoApprovedToolsDestroy,
  apiAgentsCollaboratorsCreate,
  apiAgentsCollaboratorsDestroy,
  apiAgentsCollaboratorsRetrieve,
  apiAgentsCreate,
  apiAgentsDestroy,
  apiAgentsList,
  apiAgentsMcpServersCreate,
  apiAgentsMcpServersDestroy,
  apiAgentsMcpServersList,
  apiAgentsMcpServersPartialUpdate,
  apiAgentsMemoriesCreate,
  apiAgentsMemoriesDestroy,
  apiAgentsMemoriesDocumentsConfirmCreate,
  apiAgentsMemoriesDocumentsCreate,
  apiAgentsMemoriesDocumentsDestroy,
  apiAgentsMemoriesDocumentsList,
  apiAgentsMemoriesDocumentsRetrieve,
  apiAgentsMemoriesDocumentsSearchCreate,
  apiAgentsMemoriesList,
  apiAgentsMemoriesPartialUpdate,
  apiAgentsMemoriesRetrieve,
  apiAgentsMemoriesUpdate,
  apiAgentsMemorySourceRetrieve,
  apiAgentsMemorySourceUpdate,
  apiAgentsPartialUpdate,
  apiAgentsRetrieve,
  apiAgentsScaffoldCreate,
  apiAgentsSharepointFilesEventsList,
  apiAgentsSharepointFilesList,
  apiAgentsSharepointScopeRetrieve,
  apiAgentsSharepointScopeValidateCreate,
  apiAgentsSharepointSyncCreate,
  apiAgentsSharepointSyncRunsList,
  apiAgentsSharepointSyncRunsRetrieve,
  apiAgentsSkillsAttachCreate,
  apiAgentsSkillsDetachOrToggleDestroy,
  apiAgentsSkillsDetachOrTogglePartialUpdate,
  apiAgentsSkillsList,
  apiAgentsToolsRetrieve,
  apiAgentsToolsUpdate,
  apiAgentsUpdate,
  apiApprovalsList,
  apiApprovalsPoliciesList,
  apiApprovalsRetrieve,
  apiApprovalsStatsRetrieve,
  apiCardPauseCreate,
  apiCardPauseRetrieve,
  apiChannelsCreate,
  apiChannelsCrmSubscriptionDestroy,
  apiChannelsCrmSubscriptionRetrieve,
  apiChannelsCrmSubscriptionUpdate,
  apiChannelsDestroy,
  apiChannelsList,
  apiChannelsPartialUpdate,
  apiChannelsRetrieve,
  apiChannelsRotateSecretCreate,
  apiChannelsUpdate,
  apiChannelsWebhookCreate,
  apiChatCreate,
  apiChatFilesConfirmCreate,
  apiChatFilesCreate,
  apiChatFilesDestroy,
  apiChatFilesDownloadRetrieve,
  apiChatResumeCreate,
  apiMcpCatalogConnectCreate,
  apiMcpCatalogDisconnectCreate,
  apiMcpCatalogList,
  apiMcpCatalogToolsList,
  apiMcpOauthCallbackRetrieve,
  apiMcpServersCreate,
  apiMcpServersDestroy,
  apiMcpServersList,
  apiMcpServersOauthDisconnectCreate,
  apiMcpServersOauthRetrieve,
  apiMcpServersOauthStartCreate,
  apiMcpServersPartialUpdate,
  apiMcpServersRetrieve,
  apiMcpServersUpdate,
  apiMeRetrieve,
  apiMicrosoftGraphAdminConsentCallbackRetrieve,
  apiMicrosoftGraphAdminConsentRevokeCreate,
  apiMicrosoftGraphAdminConsentStartCreate,
  apiMicrosoftGraphAdminConsentStatusRetrieve,
  apiMicrosoftGraphBrowseDrivesChildrenRetrieve,
  apiMicrosoftGraphBrowseDrivesSearchRetrieve,
  apiMicrosoftGraphBrowseSitesDrivesRetrieve,
  apiMicrosoftGraphBrowseSitesRetrieve,
  apiMicrosoftGraphConnectCallbackRetrieve,
  apiMicrosoftGraphConnectStartCreate,
  apiMicrosoftGraphDisconnectCreate,
  apiMicrosoftGraphStatusRetrieve,
  apiObservabilityFeedbackRetrieve,
  apiObservabilityMetricsRetrieve,
  apiObservabilityModelsRetrieve,
  apiObservabilityRunsFeedbackDestroy,
  apiObservabilityRunsFeedbackUpdate,
  apiObservabilitySummaryRetrieve,
  apiObservabilityThreadsRatingsRetrieve,
  apiObservabilityThreadsRetrieve,
  apiObservabilityTracesFeedbackDestroy,
  apiObservabilityTracesFeedbackUpdate,
  apiObservabilityTracesRetrieve,
  apiObservabilityTracesRetrieve2,
  apiProvidersModelsRetrieve,
  apiProvidersRetrieve,
  apiRunsCancelCreate,
  apiRunsClearDestroy,
  apiRunsDestroy,
  apiRunsList,
  apiRunsRetrieve,
  apiRunsStepsList,
  apiRunsStreamRetrieve,
  apiSchedulesCreate,
  apiSchedulesDestroy,
  apiSchedulesList,
  apiSchedulesPartialUpdate,
  apiSchedulesRetrieve,
  apiSchedulesUpdate,
  apiSkillsCreate,
  apiSkillsDestroy,
  apiSkillsList,
  apiSkillsPartialUpdate,
  apiSkillsRetrieve,
  apiSkillsUpdate,
  apiTemplatesList,
  apiTemplatesRetrieve,
  apiTemplatesUseCreate,
  apiThreadsCompactCreate,
  apiThreadsDestroy,
  apiThreadsFilesList,
  apiThreadsList,
  apiThreadsMessagesRetrieve,
  apiThreadsRenamePartialUpdate,
  apiThreadsRetrieve,
  apiToolsRetrieve,
  apiUsageBreakdownRetrieve,
  apiUsagePlatformSummaryRetrieve,
  apiUsageSummaryRetrieve,
  apiVoiceConfigRetrieve,
  apiVoiceSttCreate,
  apiVoiceTtsCreate,
  apiVoiceVoicesRetrieve,
  apiWidgetChatCreate,
  apiWidgetConfigRetrieve,
  apiWidgetMessagesRetrieve,
  apiWidgetOperatorMessagesRetrieve,
  apiWidgetResumeCreate,
  apiWidgetsCreate,
  apiWidgetsDestroy,
  apiWidgetsList,
  apiWidgetsPartialUpdate,
  apiWidgetsRetrieve,
  apiWidgetsRotateKeyCreate,
  apiWidgetsUpdate,
  apiWidgetVoiceSttCreate,
  apiWidgetVoiceTtsCreate,
  mcpToolsCallCreate,
  mcpToolsRetrieve,
  type Options
} from '../sdk.gen'
import type {
  ApiAgentsAssigneesCreateData,
  ApiAgentsAssigneesCreateResponse,
  ApiAgentsAssigneesDestroyData,
  ApiAgentsAssigneesDestroyResponse,
  ApiAgentsAssigneesRetrieveData,
  ApiAgentsAssigneesRetrieveResponse,
  ApiAgentsAutoApprovedToolsDestroyData,
  ApiAgentsAutoApprovedToolsDestroyResponse,
  ApiAgentsCollaboratorsCreateData,
  ApiAgentsCollaboratorsCreateResponse,
  ApiAgentsCollaboratorsDestroyData,
  ApiAgentsCollaboratorsDestroyResponse,
  ApiAgentsCollaboratorsRetrieveData,
  ApiAgentsCollaboratorsRetrieveResponse,
  ApiAgentsCreateData,
  ApiAgentsCreateResponse,
  ApiAgentsDestroyData,
  ApiAgentsDestroyResponse,
  ApiAgentsListData,
  ApiAgentsListResponse,
  ApiAgentsMcpServersCreateData,
  ApiAgentsMcpServersCreateResponse,
  ApiAgentsMcpServersDestroyData,
  ApiAgentsMcpServersDestroyResponse,
  ApiAgentsMcpServersListData,
  ApiAgentsMcpServersListResponse,
  ApiAgentsMcpServersPartialUpdateData,
  ApiAgentsMcpServersPartialUpdateResponse,
  ApiAgentsMemoriesCreateData,
  ApiAgentsMemoriesCreateResponse,
  ApiAgentsMemoriesDestroyData,
  ApiAgentsMemoriesDestroyResponse,
  ApiAgentsMemoriesDocumentsConfirmCreateData,
  ApiAgentsMemoriesDocumentsConfirmCreateResponse,
  ApiAgentsMemoriesDocumentsCreateData,
  ApiAgentsMemoriesDocumentsCreateResponse,
  ApiAgentsMemoriesDocumentsDestroyData,
  ApiAgentsMemoriesDocumentsDestroyResponse,
  ApiAgentsMemoriesDocumentsListData,
  ApiAgentsMemoriesDocumentsListResponse,
  ApiAgentsMemoriesDocumentsRetrieveData,
  ApiAgentsMemoriesDocumentsRetrieveResponse,
  ApiAgentsMemoriesDocumentsSearchCreateData,
  ApiAgentsMemoriesDocumentsSearchCreateResponse,
  ApiAgentsMemoriesListData,
  ApiAgentsMemoriesListResponse,
  ApiAgentsMemoriesPartialUpdateData,
  ApiAgentsMemoriesPartialUpdateResponse,
  ApiAgentsMemoriesRetrieveData,
  ApiAgentsMemoriesRetrieveResponse,
  ApiAgentsMemoriesUpdateData,
  ApiAgentsMemoriesUpdateResponse,
  ApiAgentsMemorySourceRetrieveData,
  ApiAgentsMemorySourceRetrieveResponse,
  ApiAgentsMemorySourceUpdateData,
  ApiAgentsMemorySourceUpdateResponse,
  ApiAgentsPartialUpdateData,
  ApiAgentsPartialUpdateResponse,
  ApiAgentsRetrieveData,
  ApiAgentsRetrieveResponse,
  ApiAgentsScaffoldCreateData,
  ApiAgentsSharepointFilesEventsListData,
  ApiAgentsSharepointFilesEventsListResponse,
  ApiAgentsSharepointFilesListData,
  ApiAgentsSharepointFilesListResponse,
  ApiAgentsSharepointScopeRetrieveData,
  ApiAgentsSharepointScopeRetrieveResponse,
  ApiAgentsSharepointScopeValidateCreateData,
  ApiAgentsSharepointScopeValidateCreateResponse,
  ApiAgentsSharepointSyncCreateData,
  ApiAgentsSharepointSyncCreateResponse,
  ApiAgentsSharepointSyncRunsListData,
  ApiAgentsSharepointSyncRunsListResponse,
  ApiAgentsSharepointSyncRunsRetrieveData,
  ApiAgentsSharepointSyncRunsRetrieveResponse,
  ApiAgentsSkillsAttachCreateData,
  ApiAgentsSkillsAttachCreateResponse,
  ApiAgentsSkillsDetachOrToggleDestroyData,
  ApiAgentsSkillsDetachOrToggleDestroyResponse,
  ApiAgentsSkillsDetachOrTogglePartialUpdateData,
  ApiAgentsSkillsDetachOrTogglePartialUpdateResponse,
  ApiAgentsSkillsListData,
  ApiAgentsSkillsListResponse,
  ApiAgentsToolsRetrieveData,
  ApiAgentsToolsRetrieveResponse,
  ApiAgentsToolsUpdateData,
  ApiAgentsToolsUpdateResponse,
  ApiAgentsUpdateData,
  ApiAgentsUpdateResponse,
  ApiApprovalsListData,
  ApiApprovalsListResponse,
  ApiApprovalsPoliciesListData,
  ApiApprovalsPoliciesListResponse,
  ApiApprovalsRetrieveData,
  ApiApprovalsRetrieveResponse,
  ApiApprovalsStatsRetrieveData,
  ApiApprovalsStatsRetrieveResponse,
  ApiCardPauseCreateData,
  ApiCardPauseCreateResponse,
  ApiCardPauseRetrieveData,
  ApiCardPauseRetrieveResponse,
  ApiChannelsCreateData,
  ApiChannelsCreateResponse,
  ApiChannelsCrmSubscriptionDestroyData,
  ApiChannelsCrmSubscriptionDestroyResponse,
  ApiChannelsCrmSubscriptionRetrieveData,
  ApiChannelsCrmSubscriptionRetrieveResponse,
  ApiChannelsCrmSubscriptionUpdateData,
  ApiChannelsCrmSubscriptionUpdateResponse,
  ApiChannelsDestroyData,
  ApiChannelsDestroyResponse,
  ApiChannelsListData,
  ApiChannelsListResponse,
  ApiChannelsPartialUpdateData,
  ApiChannelsPartialUpdateResponse,
  ApiChannelsRetrieveData,
  ApiChannelsRetrieveResponse,
  ApiChannelsRotateSecretCreateData,
  ApiChannelsRotateSecretCreateResponse,
  ApiChannelsUpdateData,
  ApiChannelsUpdateResponse,
  ApiChannelsWebhookCreateData,
  ApiChatCreateData,
  ApiChatFilesConfirmCreateData,
  ApiChatFilesConfirmCreateResponse,
  ApiChatFilesCreateData,
  ApiChatFilesCreateResponse,
  ApiChatFilesDestroyData,
  ApiChatFilesDestroyResponse,
  ApiChatFilesDownloadRetrieveData,
  ApiChatFilesDownloadRetrieveResponse,
  ApiChatResumeCreateData,
  ApiChatResumeCreateResponse,
  ApiMcpCatalogConnectCreateData,
  ApiMcpCatalogConnectCreateResponse,
  ApiMcpCatalogDisconnectCreateData,
  ApiMcpCatalogDisconnectCreateResponse,
  ApiMcpCatalogListData,
  ApiMcpCatalogListResponse,
  ApiMcpCatalogToolsListData,
  ApiMcpCatalogToolsListResponse,
  ApiMcpOauthCallbackRetrieveData,
  ApiMcpServersCreateData,
  ApiMcpServersCreateResponse,
  ApiMcpServersDestroyData,
  ApiMcpServersDestroyResponse,
  ApiMcpServersListData,
  ApiMcpServersListResponse,
  ApiMcpServersOauthDisconnectCreateData,
  ApiMcpServersOauthDisconnectCreateResponse,
  ApiMcpServersOauthRetrieveData,
  ApiMcpServersOauthRetrieveResponse,
  ApiMcpServersOauthStartCreateData,
  ApiMcpServersOauthStartCreateResponse,
  ApiMcpServersPartialUpdateData,
  ApiMcpServersPartialUpdateResponse,
  ApiMcpServersRetrieveData,
  ApiMcpServersRetrieveResponse,
  ApiMcpServersUpdateData,
  ApiMcpServersUpdateResponse,
  ApiMeRetrieveData,
  ApiMeRetrieveResponse,
  ApiMicrosoftGraphAdminConsentCallbackRetrieveData,
  ApiMicrosoftGraphAdminConsentRevokeCreateData,
  ApiMicrosoftGraphAdminConsentRevokeCreateResponse,
  ApiMicrosoftGraphAdminConsentStartCreateData,
  ApiMicrosoftGraphAdminConsentStartCreateResponse,
  ApiMicrosoftGraphAdminConsentStatusRetrieveData,
  ApiMicrosoftGraphAdminConsentStatusRetrieveResponse,
  ApiMicrosoftGraphBrowseDrivesChildrenRetrieveData,
  ApiMicrosoftGraphBrowseDrivesChildrenRetrieveResponse,
  ApiMicrosoftGraphBrowseDrivesSearchRetrieveData,
  ApiMicrosoftGraphBrowseDrivesSearchRetrieveResponse,
  ApiMicrosoftGraphBrowseSitesDrivesRetrieveData,
  ApiMicrosoftGraphBrowseSitesDrivesRetrieveResponse,
  ApiMicrosoftGraphBrowseSitesRetrieveData,
  ApiMicrosoftGraphBrowseSitesRetrieveResponse,
  ApiMicrosoftGraphConnectCallbackRetrieveData,
  ApiMicrosoftGraphConnectStartCreateData,
  ApiMicrosoftGraphConnectStartCreateResponse,
  ApiMicrosoftGraphDisconnectCreateData,
  ApiMicrosoftGraphDisconnectCreateResponse,
  ApiMicrosoftGraphStatusRetrieveData,
  ApiMicrosoftGraphStatusRetrieveResponse,
  ApiObservabilityFeedbackRetrieveData,
  ApiObservabilityMetricsRetrieveData,
  ApiObservabilityModelsRetrieveData,
  ApiObservabilityRunsFeedbackDestroyData,
  ApiObservabilityRunsFeedbackDestroyResponse,
  ApiObservabilityRunsFeedbackUpdateData,
  ApiObservabilitySummaryRetrieveData,
  ApiObservabilityThreadsRatingsRetrieveData,
  ApiObservabilityThreadsRetrieveData,
  ApiObservabilityTracesFeedbackDestroyData,
  ApiObservabilityTracesFeedbackDestroyResponse,
  ApiObservabilityTracesFeedbackUpdateData,
  ApiObservabilityTracesRetrieve2Data,
  ApiObservabilityTracesRetrieveData,
  ApiProvidersModelsRetrieveData,
  ApiProvidersRetrieveData,
  ApiRunsCancelCreateData,
  ApiRunsCancelCreateResponse,
  ApiRunsClearDestroyData,
  ApiRunsClearDestroyResponse,
  ApiRunsDestroyData,
  ApiRunsDestroyResponse,
  ApiRunsListData,
  ApiRunsListResponse,
  ApiRunsRetrieveData,
  ApiRunsRetrieveResponse,
  ApiRunsStepsListData,
  ApiRunsStepsListResponse,
  ApiRunsStreamRetrieveData,
  ApiSchedulesCreateData,
  ApiSchedulesCreateResponse,
  ApiSchedulesDestroyData,
  ApiSchedulesDestroyResponse,
  ApiSchedulesListData,
  ApiSchedulesListResponse,
  ApiSchedulesPartialUpdateData,
  ApiSchedulesPartialUpdateResponse,
  ApiSchedulesRetrieveData,
  ApiSchedulesRetrieveResponse,
  ApiSchedulesUpdateData,
  ApiSchedulesUpdateResponse,
  ApiSkillsCreateData,
  ApiSkillsCreateResponse,
  ApiSkillsDestroyData,
  ApiSkillsDestroyResponse,
  ApiSkillsListData,
  ApiSkillsListResponse,
  ApiSkillsPartialUpdateData,
  ApiSkillsPartialUpdateResponse,
  ApiSkillsRetrieveData,
  ApiSkillsRetrieveResponse,
  ApiSkillsUpdateData,
  ApiSkillsUpdateResponse,
  ApiTemplatesListData,
  ApiTemplatesListResponse,
  ApiTemplatesRetrieveData,
  ApiTemplatesRetrieveResponse,
  ApiTemplatesUseCreateData,
  ApiThreadsCompactCreateData,
  ApiThreadsCompactCreateResponse,
  ApiThreadsDestroyData,
  ApiThreadsDestroyResponse,
  ApiThreadsFilesListData,
  ApiThreadsFilesListResponse,
  ApiThreadsListData,
  ApiThreadsListResponse,
  ApiThreadsMessagesRetrieveData,
  ApiThreadsMessagesRetrieveResponse,
  ApiThreadsRenamePartialUpdateData,
  ApiThreadsRenamePartialUpdateResponse,
  ApiThreadsRetrieveData,
  ApiThreadsRetrieveResponse,
  ApiToolsRetrieveData,
  ApiUsageBreakdownRetrieveData,
  ApiUsagePlatformSummaryRetrieveData,
  ApiUsageSummaryRetrieveData,
  ApiVoiceConfigRetrieveData,
  ApiVoiceSttCreateData,
  ApiVoiceTtsCreateData,
  ApiVoiceTtsCreateResponse,
  ApiVoiceVoicesRetrieveData,
  ApiWidgetChatCreateData,
  ApiWidgetConfigRetrieveData,
  ApiWidgetMessagesRetrieveData,
  ApiWidgetOperatorMessagesRetrieveData,
  ApiWidgetResumeCreateData,
  ApiWidgetsCreateData,
  ApiWidgetsCreateResponse,
  ApiWidgetsDestroyData,
  ApiWidgetsDestroyResponse,
  ApiWidgetsListData,
  ApiWidgetsListResponse,
  ApiWidgetsPartialUpdateData,
  ApiWidgetsPartialUpdateResponse,
  ApiWidgetsRetrieveData,
  ApiWidgetsRetrieveResponse,
  ApiWidgetsRotateKeyCreateData,
  ApiWidgetsRotateKeyCreateResponse,
  ApiWidgetsUpdateData,
  ApiWidgetsUpdateResponse,
  ApiWidgetVoiceSttCreateData,
  ApiWidgetVoiceTtsCreateData,
  ApiWidgetVoiceTtsCreateResponse,
  McpToolsCallCreateData,
  McpToolsRetrieveData
} from '../types.gen'

export type QueryKey<TOptions extends Options> = [
  Pick<TOptions, 'baseURL' | 'body' | 'headers' | 'path' | 'query'> & {
    _id: string
    _infinite?: boolean
    tags?: ReadonlyArray<string>
  }
]

const createQueryKey = <TOptions extends Options>(
  id: string,
  options?: TOptions,
  infinite?: boolean,
  tags?: ReadonlyArray<string>
): [QueryKey<TOptions>[0]] => {
  const params: QueryKey<TOptions>[0] = {
    _id: id,
    baseURL: options?.baseURL || (options?.client ?? client).getConfig().baseURL
  } as QueryKey<TOptions>[0]
  if (infinite) {
    params._infinite = infinite
  }
  if (tags) {
    params.tags = tags
  }
  if (options?.body) {
    params.body = options.body
  }
  if (options?.headers) {
    params.headers = options.headers
  }
  if (options?.path) {
    params.path = options.path
  }
  if (options?.query) {
    params.query = options.query
  }
  return [params]
}

export const apiAgentsListQueryKey = (options?: Options<ApiAgentsListData>) =>
  createQueryKey('apiAgentsList', options)

export const apiAgentsListOptions = (options?: Options<ApiAgentsListData>) =>
  queryOptions<
    ApiAgentsListResponse,
    AxiosError<DefaultError>,
    ApiAgentsListResponse,
    ReturnType<typeof apiAgentsListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiAgentsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiAgentsListQueryKey(options)
  })

export const apiAgentsCreateMutation = (
  options?: Partial<Options<ApiAgentsCreateData>>
): UseMutationOptions<
  ApiAgentsCreateResponse,
  AxiosError<DefaultError>,
  Options<ApiAgentsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiAgentsCreateResponse,
    AxiosError<DefaultError>,
    Options<ApiAgentsCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiAgentsCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiAgentsMcpServersListQueryKey = (
  options: Options<ApiAgentsMcpServersListData>
) => createQueryKey('apiAgentsMcpServersList', options)

/**
 * `/api/agents/<agent_id>/mcp-servers/` — list & attach & detach.
 *
 * Standard DRF verbs:
 * GET    /  → list links of an agent
 * POST   /  → attach server to agent (body: {"server": <uuid>, "is_enabled": bool})
 * DELETE /<id>/ → detach a link
 * PATCH  /<id>/ → toggle `is_enabled`
 */
export const apiAgentsMcpServersListOptions = (
  options: Options<ApiAgentsMcpServersListData>
) =>
  queryOptions<
    ApiAgentsMcpServersListResponse,
    AxiosError<DefaultError>,
    ApiAgentsMcpServersListResponse,
    ReturnType<typeof apiAgentsMcpServersListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiAgentsMcpServersList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiAgentsMcpServersListQueryKey(options)
  })

/**
 * `/api/agents/<agent_id>/mcp-servers/` — list & attach & detach.
 *
 * Standard DRF verbs:
 * GET    /  → list links of an agent
 * POST   /  → attach server to agent (body: {"server": <uuid>, "is_enabled": bool})
 * DELETE /<id>/ → detach a link
 * PATCH  /<id>/ → toggle `is_enabled`
 */
export const apiAgentsMcpServersCreateMutation = (
  options?: Partial<Options<ApiAgentsMcpServersCreateData>>
): UseMutationOptions<
  ApiAgentsMcpServersCreateResponse,
  AxiosError<DefaultError>,
  Options<ApiAgentsMcpServersCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiAgentsMcpServersCreateResponse,
    AxiosError<DefaultError>,
    Options<ApiAgentsMcpServersCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiAgentsMcpServersCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * `/api/agents/<agent_id>/mcp-servers/` — list & attach & detach.
 *
 * Standard DRF verbs:
 * GET    /  → list links of an agent
 * POST   /  → attach server to agent (body: {"server": <uuid>, "is_enabled": bool})
 * DELETE /<id>/ → detach a link
 * PATCH  /<id>/ → toggle `is_enabled`
 */
export const apiAgentsMcpServersDestroyMutation = (
  options?: Partial<Options<ApiAgentsMcpServersDestroyData>>
): UseMutationOptions<
  ApiAgentsMcpServersDestroyResponse,
  AxiosError<DefaultError>,
  Options<ApiAgentsMcpServersDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiAgentsMcpServersDestroyResponse,
    AxiosError<DefaultError>,
    Options<ApiAgentsMcpServersDestroyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiAgentsMcpServersDestroy({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * `/api/agents/<agent_id>/mcp-servers/` — list & attach & detach.
 *
 * Standard DRF verbs:
 * GET    /  → list links of an agent
 * POST   /  → attach server to agent (body: {"server": <uuid>, "is_enabled": bool})
 * DELETE /<id>/ → detach a link
 * PATCH  /<id>/ → toggle `is_enabled`
 */
export const apiAgentsMcpServersPartialUpdateMutation = (
  options?: Partial<Options<ApiAgentsMcpServersPartialUpdateData>>
): UseMutationOptions<
  ApiAgentsMcpServersPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<ApiAgentsMcpServersPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiAgentsMcpServersPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<ApiAgentsMcpServersPartialUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiAgentsMcpServersPartialUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiAgentsMemoriesListQueryKey = (
  options: Options<ApiAgentsMemoriesListData>
) => createQueryKey('apiAgentsMemoriesList', options)

export const apiAgentsMemoriesListOptions = (
  options: Options<ApiAgentsMemoriesListData>
) =>
  queryOptions<
    ApiAgentsMemoriesListResponse,
    AxiosError<DefaultError>,
    ApiAgentsMemoriesListResponse,
    ReturnType<typeof apiAgentsMemoriesListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiAgentsMemoriesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiAgentsMemoriesListQueryKey(options)
  })

export const apiAgentsMemoriesCreateMutation = (
  options?: Partial<Options<ApiAgentsMemoriesCreateData>>
): UseMutationOptions<
  ApiAgentsMemoriesCreateResponse,
  AxiosError<DefaultError>,
  Options<ApiAgentsMemoriesCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiAgentsMemoriesCreateResponse,
    AxiosError<DefaultError>,
    Options<ApiAgentsMemoriesCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiAgentsMemoriesCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiAgentsMemoriesDestroyMutation = (
  options?: Partial<Options<ApiAgentsMemoriesDestroyData>>
): UseMutationOptions<
  ApiAgentsMemoriesDestroyResponse,
  AxiosError<DefaultError>,
  Options<ApiAgentsMemoriesDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiAgentsMemoriesDestroyResponse,
    AxiosError<DefaultError>,
    Options<ApiAgentsMemoriesDestroyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiAgentsMemoriesDestroy({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiAgentsMemoriesRetrieveQueryKey = (
  options: Options<ApiAgentsMemoriesRetrieveData>
) => createQueryKey('apiAgentsMemoriesRetrieve', options)

export const apiAgentsMemoriesRetrieveOptions = (
  options: Options<ApiAgentsMemoriesRetrieveData>
) =>
  queryOptions<
    ApiAgentsMemoriesRetrieveResponse,
    AxiosError<DefaultError>,
    ApiAgentsMemoriesRetrieveResponse,
    ReturnType<typeof apiAgentsMemoriesRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiAgentsMemoriesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiAgentsMemoriesRetrieveQueryKey(options)
  })

export const apiAgentsMemoriesPartialUpdateMutation = (
  options?: Partial<Options<ApiAgentsMemoriesPartialUpdateData>>
): UseMutationOptions<
  ApiAgentsMemoriesPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<ApiAgentsMemoriesPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiAgentsMemoriesPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<ApiAgentsMemoriesPartialUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiAgentsMemoriesPartialUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiAgentsMemoriesUpdateMutation = (
  options?: Partial<Options<ApiAgentsMemoriesUpdateData>>
): UseMutationOptions<
  ApiAgentsMemoriesUpdateResponse,
  AxiosError<DefaultError>,
  Options<ApiAgentsMemoriesUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiAgentsMemoriesUpdateResponse,
    AxiosError<DefaultError>,
    Options<ApiAgentsMemoriesUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiAgentsMemoriesUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiAgentsMemoriesDocumentsListQueryKey = (
  options: Options<ApiAgentsMemoriesDocumentsListData>
) => createQueryKey('apiAgentsMemoriesDocumentsList', options)

export const apiAgentsMemoriesDocumentsListOptions = (
  options: Options<ApiAgentsMemoriesDocumentsListData>
) =>
  queryOptions<
    ApiAgentsMemoriesDocumentsListResponse,
    AxiosError<DefaultError>,
    ApiAgentsMemoriesDocumentsListResponse,
    ReturnType<typeof apiAgentsMemoriesDocumentsListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiAgentsMemoriesDocumentsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiAgentsMemoriesDocumentsListQueryKey(options)
  })

/**
 * Issue a presigned PUT URL + create the `pending` row.
 *
 * No blob touches this process and no parsing is enqueued yet — that
 * happens on `confirm`, once the browser has PUT the bytes to MinIO.
 */
export const apiAgentsMemoriesDocumentsCreateMutation = (
  options?: Partial<Options<ApiAgentsMemoriesDocumentsCreateData>>
): UseMutationOptions<
  ApiAgentsMemoriesDocumentsCreateResponse,
  AxiosError<DefaultError>,
  Options<ApiAgentsMemoriesDocumentsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiAgentsMemoriesDocumentsCreateResponse,
    AxiosError<DefaultError>,
    Options<ApiAgentsMemoriesDocumentsCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiAgentsMemoriesDocumentsCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiAgentsMemoriesDocumentsDestroyMutation = (
  options?: Partial<Options<ApiAgentsMemoriesDocumentsDestroyData>>
): UseMutationOptions<
  ApiAgentsMemoriesDocumentsDestroyResponse,
  AxiosError<DefaultError>,
  Options<ApiAgentsMemoriesDocumentsDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiAgentsMemoriesDocumentsDestroyResponse,
    AxiosError<DefaultError>,
    Options<ApiAgentsMemoriesDocumentsDestroyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiAgentsMemoriesDocumentsDestroy({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiAgentsMemoriesDocumentsRetrieveQueryKey = (
  options: Options<ApiAgentsMemoriesDocumentsRetrieveData>
) => createQueryKey('apiAgentsMemoriesDocumentsRetrieve', options)

export const apiAgentsMemoriesDocumentsRetrieveOptions = (
  options: Options<ApiAgentsMemoriesDocumentsRetrieveData>
) =>
  queryOptions<
    ApiAgentsMemoriesDocumentsRetrieveResponse,
    AxiosError<DefaultError>,
    ApiAgentsMemoriesDocumentsRetrieveResponse,
    ReturnType<typeof apiAgentsMemoriesDocumentsRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiAgentsMemoriesDocumentsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiAgentsMemoriesDocumentsRetrieveQueryKey(options)
  })

/**
 * Finalise a presigned upload once the browser's PUT completed.
 *
 * Verifies the object exists, enforces the size limit against its real
 * size (the authoritative gate), then kicks off parsing. Idempotent: a
 * doc that's already past `pending` is returned unchanged.
 */
export const apiAgentsMemoriesDocumentsConfirmCreateMutation = (
  options?: Partial<Options<ApiAgentsMemoriesDocumentsConfirmCreateData>>
): UseMutationOptions<
  ApiAgentsMemoriesDocumentsConfirmCreateResponse,
  AxiosError<DefaultError>,
  Options<ApiAgentsMemoriesDocumentsConfirmCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiAgentsMemoriesDocumentsConfirmCreateResponse,
    AxiosError<DefaultError>,
    Options<ApiAgentsMemoriesDocumentsConfirmCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiAgentsMemoriesDocumentsConfirmCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Semantic search over this agent's chunks.
 *
 * Mirrors the runtime tool `squad_runtime.tools.memory_rag.memory_search`
 * — same SQL, same `embed_query`, same `(account_id, agent_id)` filter.
 * Exposed as REST so the UI can offer the same retrieval users see
 * when the agent calls the tool, with a relevance score per chunk.
 */
export const apiAgentsMemoriesDocumentsSearchCreateMutation = (
  options?: Partial<Options<ApiAgentsMemoriesDocumentsSearchCreateData>>
): UseMutationOptions<
  ApiAgentsMemoriesDocumentsSearchCreateResponse,
  AxiosError<DefaultError>,
  Options<ApiAgentsMemoriesDocumentsSearchCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiAgentsMemoriesDocumentsSearchCreateResponse,
    AxiosError<DefaultError>,
    Options<ApiAgentsMemoriesDocumentsSearchCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiAgentsMemoriesDocumentsSearchCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiAgentsMemorySourceRetrieveQueryKey = (
  options: Options<ApiAgentsMemorySourceRetrieveData>
) => createQueryKey('apiAgentsMemorySourceRetrieve', options)

export const apiAgentsMemorySourceRetrieveOptions = (
  options: Options<ApiAgentsMemorySourceRetrieveData>
) =>
  queryOptions<
    ApiAgentsMemorySourceRetrieveResponse,
    AxiosError<DefaultError>,
    ApiAgentsMemorySourceRetrieveResponse,
    ReturnType<typeof apiAgentsMemorySourceRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiAgentsMemorySourceRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiAgentsMemorySourceRetrieveQueryKey(options)
  })

export const apiAgentsMemorySourceUpdateMutation = (
  options?: Partial<Options<ApiAgentsMemorySourceUpdateData>>
): UseMutationOptions<
  ApiAgentsMemorySourceUpdateResponse,
  AxiosError<DefaultError>,
  Options<ApiAgentsMemorySourceUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiAgentsMemorySourceUpdateResponse,
    AxiosError<DefaultError>,
    Options<ApiAgentsMemorySourceUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiAgentsMemorySourceUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiAgentsSharepointFilesListQueryKey = (
  options: Options<ApiAgentsSharepointFilesListData>
) => createQueryKey('apiAgentsSharepointFilesList', options)

/**
 * `GET .../sharepoint/files/` — the Memory tab's table.
 *
 * Skipped files are listed, never hidden: "why isn't this PNG in memory" has
 * to be answerable from the UI without reading worker logs.
 */
export const apiAgentsSharepointFilesListOptions = (
  options: Options<ApiAgentsSharepointFilesListData>
) =>
  queryOptions<
    ApiAgentsSharepointFilesListResponse,
    AxiosError<DefaultError>,
    ApiAgentsSharepointFilesListResponse,
    ReturnType<typeof apiAgentsSharepointFilesListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiAgentsSharepointFilesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiAgentsSharepointFilesListQueryKey(options)
  })

export const apiAgentsSharepointFilesEventsListQueryKey = (
  options: Options<ApiAgentsSharepointFilesEventsListData>
) => createQueryKey('apiAgentsSharepointFilesEventsList', options)

/**
 * `GET .../sharepoint/files/<file_id>/events/` — one file's version journal.
 */
export const apiAgentsSharepointFilesEventsListOptions = (
  options: Options<ApiAgentsSharepointFilesEventsListData>
) =>
  queryOptions<
    ApiAgentsSharepointFilesEventsListResponse,
    AxiosError<DefaultError>,
    ApiAgentsSharepointFilesEventsListResponse,
    ReturnType<typeof apiAgentsSharepointFilesEventsListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiAgentsSharepointFilesEventsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiAgentsSharepointFilesEventsListQueryKey(options)
  })

export const apiAgentsSharepointScopeRetrieveQueryKey = (
  options: Options<ApiAgentsSharepointScopeRetrieveData>
) => createQueryKey('apiAgentsSharepointScopeRetrieve', options)

export const apiAgentsSharepointScopeRetrieveOptions = (
  options: Options<ApiAgentsSharepointScopeRetrieveData>
) =>
  queryOptions<
    ApiAgentsSharepointScopeRetrieveResponse,
    AxiosError<DefaultError>,
    ApiAgentsSharepointScopeRetrieveResponse,
    ReturnType<typeof apiAgentsSharepointScopeRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiAgentsSharepointScopeRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiAgentsSharepointScopeRetrieveQueryKey(options)
  })

/**
 * Dry-run a scope draft before it is saved.
 *
 * Runs the SAME validator the save path runs, so the preview can never
 * disagree with what saving would do, then checks each entry against Graph
 * under the caller's own connection.
 */
export const apiAgentsSharepointScopeValidateCreateMutation = (
  options?: Partial<Options<ApiAgentsSharepointScopeValidateCreateData>>
): UseMutationOptions<
  ApiAgentsSharepointScopeValidateCreateResponse,
  AxiosError<DefaultError>,
  Options<ApiAgentsSharepointScopeValidateCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiAgentsSharepointScopeValidateCreateResponse,
    AxiosError<DefaultError>,
    Options<ApiAgentsSharepointScopeValidateCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiAgentsSharepointScopeValidateCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * `POST /api/agents/<id>/sharepoint/sync/` — run one now.
 *
 * Needs write access but NOT the A2.1 admin gate: this re-runs a selection an
 * authorised person already made and adds nothing the scope does not cover.
 */
export const apiAgentsSharepointSyncCreateMutation = (
  options?: Partial<Options<ApiAgentsSharepointSyncCreateData>>
): UseMutationOptions<
  ApiAgentsSharepointSyncCreateResponse,
  AxiosError<DefaultError>,
  Options<ApiAgentsSharepointSyncCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiAgentsSharepointSyncCreateResponse,
    AxiosError<DefaultError>,
    Options<ApiAgentsSharepointSyncCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiAgentsSharepointSyncCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiAgentsSharepointSyncRunsListQueryKey = (
  options: Options<ApiAgentsSharepointSyncRunsListData>
) => createQueryKey('apiAgentsSharepointSyncRunsList', options)

/**
 * `GET .../sharepoint/sync/runs/` — newest first.
 */
export const apiAgentsSharepointSyncRunsListOptions = (
  options: Options<ApiAgentsSharepointSyncRunsListData>
) =>
  queryOptions<
    ApiAgentsSharepointSyncRunsListResponse,
    AxiosError<DefaultError>,
    ApiAgentsSharepointSyncRunsListResponse,
    ReturnType<typeof apiAgentsSharepointSyncRunsListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiAgentsSharepointSyncRunsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiAgentsSharepointSyncRunsListQueryKey(options)
  })

export const apiAgentsSharepointSyncRunsRetrieveQueryKey = (
  options: Options<ApiAgentsSharepointSyncRunsRetrieveData>
) => createQueryKey('apiAgentsSharepointSyncRunsRetrieve', options)

/**
 * `GET .../sync/runs/<run_id>/` — one run and everything it did.
 */
export const apiAgentsSharepointSyncRunsRetrieveOptions = (
  options: Options<ApiAgentsSharepointSyncRunsRetrieveData>
) =>
  queryOptions<
    ApiAgentsSharepointSyncRunsRetrieveResponse,
    AxiosError<DefaultError>,
    ApiAgentsSharepointSyncRunsRetrieveResponse,
    ReturnType<typeof apiAgentsSharepointSyncRunsRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiAgentsSharepointSyncRunsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiAgentsSharepointSyncRunsRetrieveQueryKey(options)
  })

export const apiAgentsSkillsListQueryKey = (
  options: Options<ApiAgentsSkillsListData>
) => createQueryKey('apiAgentsSkillsList', options)

/**
 * `/api/agents/<agent_id>/skills/` — list, attach, toggle, detach.
 */
export const apiAgentsSkillsListOptions = (
  options: Options<ApiAgentsSkillsListData>
) =>
  queryOptions<
    ApiAgentsSkillsListResponse,
    AxiosError<DefaultError>,
    ApiAgentsSkillsListResponse,
    ReturnType<typeof apiAgentsSkillsListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiAgentsSkillsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiAgentsSkillsListQueryKey(options)
  })

/**
 * `/api/agents/<agent_id>/skills/` — list, attach, toggle, detach.
 */
export const apiAgentsSkillsDetachOrToggleDestroyMutation = (
  options?: Partial<Options<ApiAgentsSkillsDetachOrToggleDestroyData>>
): UseMutationOptions<
  ApiAgentsSkillsDetachOrToggleDestroyResponse,
  AxiosError<DefaultError>,
  Options<ApiAgentsSkillsDetachOrToggleDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiAgentsSkillsDetachOrToggleDestroyResponse,
    AxiosError<DefaultError>,
    Options<ApiAgentsSkillsDetachOrToggleDestroyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiAgentsSkillsDetachOrToggleDestroy({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * `/api/agents/<agent_id>/skills/` — list, attach, toggle, detach.
 */
export const apiAgentsSkillsDetachOrTogglePartialUpdateMutation = (
  options?: Partial<Options<ApiAgentsSkillsDetachOrTogglePartialUpdateData>>
): UseMutationOptions<
  ApiAgentsSkillsDetachOrTogglePartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<ApiAgentsSkillsDetachOrTogglePartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiAgentsSkillsDetachOrTogglePartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<ApiAgentsSkillsDetachOrTogglePartialUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiAgentsSkillsDetachOrTogglePartialUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * `/api/agents/<agent_id>/skills/` — list, attach, toggle, detach.
 */
export const apiAgentsSkillsAttachCreateMutation = (
  options?: Partial<Options<ApiAgentsSkillsAttachCreateData>>
): UseMutationOptions<
  ApiAgentsSkillsAttachCreateResponse,
  AxiosError<DefaultError>,
  Options<ApiAgentsSkillsAttachCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiAgentsSkillsAttachCreateResponse,
    AxiosError<DefaultError>,
    Options<ApiAgentsSkillsAttachCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiAgentsSkillsAttachCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiAgentsDestroyMutation = (
  options?: Partial<Options<ApiAgentsDestroyData>>
): UseMutationOptions<
  ApiAgentsDestroyResponse,
  AxiosError<DefaultError>,
  Options<ApiAgentsDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiAgentsDestroyResponse,
    AxiosError<DefaultError>,
    Options<ApiAgentsDestroyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiAgentsDestroy({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiAgentsRetrieveQueryKey = (
  options: Options<ApiAgentsRetrieveData>
) => createQueryKey('apiAgentsRetrieve', options)

export const apiAgentsRetrieveOptions = (
  options: Options<ApiAgentsRetrieveData>
) =>
  queryOptions<
    ApiAgentsRetrieveResponse,
    AxiosError<DefaultError>,
    ApiAgentsRetrieveResponse,
    ReturnType<typeof apiAgentsRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiAgentsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiAgentsRetrieveQueryKey(options)
  })

export const apiAgentsPartialUpdateMutation = (
  options?: Partial<Options<ApiAgentsPartialUpdateData>>
): UseMutationOptions<
  ApiAgentsPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<ApiAgentsPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiAgentsPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<ApiAgentsPartialUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiAgentsPartialUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiAgentsUpdateMutation = (
  options?: Partial<Options<ApiAgentsUpdateData>>
): UseMutationOptions<
  ApiAgentsUpdateResponse,
  AxiosError<DefaultError>,
  Options<ApiAgentsUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiAgentsUpdateResponse,
    AxiosError<DefaultError>,
    Options<ApiAgentsUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiAgentsUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiAgentsAssigneesRetrieveQueryKey = (
  options: Options<ApiAgentsAssigneesRetrieveData>
) => createQueryKey('apiAgentsAssigneesRetrieve', options)

/**
 * Run-only assignment: `viewer` collaborators who may RUN but not edit.
 *
 * Distinct from `collaborators` (owner/editor management): the role is
 * forced to `viewer` here, and GET returns only assignees. Used to grant a
 * `restricted` agent to specific users (e.g. a per-seller Follow-Up agent).
 * Gated by the same write authorization as any other agent mutation.
 */
export const apiAgentsAssigneesRetrieveOptions = (
  options: Options<ApiAgentsAssigneesRetrieveData>
) =>
  queryOptions<
    ApiAgentsAssigneesRetrieveResponse,
    AxiosError<DefaultError>,
    ApiAgentsAssigneesRetrieveResponse,
    ReturnType<typeof apiAgentsAssigneesRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiAgentsAssigneesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiAgentsAssigneesRetrieveQueryKey(options)
  })

/**
 * Run-only assignment: `viewer` collaborators who may RUN but not edit.
 *
 * Distinct from `collaborators` (owner/editor management): the role is
 * forced to `viewer` here, and GET returns only assignees. Used to grant a
 * `restricted` agent to specific users (e.g. a per-seller Follow-Up agent).
 * Gated by the same write authorization as any other agent mutation.
 */
export const apiAgentsAssigneesCreateMutation = (
  options?: Partial<Options<ApiAgentsAssigneesCreateData>>
): UseMutationOptions<
  ApiAgentsAssigneesCreateResponse,
  AxiosError<DefaultError>,
  Options<ApiAgentsAssigneesCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiAgentsAssigneesCreateResponse,
    AxiosError<DefaultError>,
    Options<ApiAgentsAssigneesCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiAgentsAssigneesCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiAgentsAssigneesDestroyMutation = (
  options?: Partial<Options<ApiAgentsAssigneesDestroyData>>
): UseMutationOptions<
  ApiAgentsAssigneesDestroyResponse,
  AxiosError<DefaultError>,
  Options<ApiAgentsAssigneesDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiAgentsAssigneesDestroyResponse,
    AxiosError<DefaultError>,
    Options<ApiAgentsAssigneesDestroyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiAgentsAssigneesDestroy({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Revoke ONE of the caller's own "Always approve" exceptions for this
 * agent (see AgentAutoApprovedTool). Scoped to the caller's own sso_id —
 * no `_assert_can_write`: this is a personal preference, not an agent
 * edit, so anyone who can reach the agent may revoke their own entry,
 * never anyone else's.
 */
export const apiAgentsAutoApprovedToolsDestroyMutation = (
  options?: Partial<Options<ApiAgentsAutoApprovedToolsDestroyData>>
): UseMutationOptions<
  ApiAgentsAutoApprovedToolsDestroyResponse,
  AxiosError<DefaultError>,
  Options<ApiAgentsAutoApprovedToolsDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiAgentsAutoApprovedToolsDestroyResponse,
    AxiosError<DefaultError>,
    Options<ApiAgentsAutoApprovedToolsDestroyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiAgentsAutoApprovedToolsDestroy({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiAgentsCollaboratorsRetrieveQueryKey = (
  options: Options<ApiAgentsCollaboratorsRetrieveData>
) => createQueryKey('apiAgentsCollaboratorsRetrieve', options)

export const apiAgentsCollaboratorsRetrieveOptions = (
  options: Options<ApiAgentsCollaboratorsRetrieveData>
) =>
  queryOptions<
    ApiAgentsCollaboratorsRetrieveResponse,
    AxiosError<DefaultError>,
    ApiAgentsCollaboratorsRetrieveResponse,
    ReturnType<typeof apiAgentsCollaboratorsRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiAgentsCollaboratorsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiAgentsCollaboratorsRetrieveQueryKey(options)
  })

export const apiAgentsCollaboratorsCreateMutation = (
  options?: Partial<Options<ApiAgentsCollaboratorsCreateData>>
): UseMutationOptions<
  ApiAgentsCollaboratorsCreateResponse,
  AxiosError<DefaultError>,
  Options<ApiAgentsCollaboratorsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiAgentsCollaboratorsCreateResponse,
    AxiosError<DefaultError>,
    Options<ApiAgentsCollaboratorsCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiAgentsCollaboratorsCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiAgentsCollaboratorsDestroyMutation = (
  options?: Partial<Options<ApiAgentsCollaboratorsDestroyData>>
): UseMutationOptions<
  ApiAgentsCollaboratorsDestroyResponse,
  AxiosError<DefaultError>,
  Options<ApiAgentsCollaboratorsDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiAgentsCollaboratorsDestroyResponse,
    AxiosError<DefaultError>,
    Options<ApiAgentsCollaboratorsDestroyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiAgentsCollaboratorsDestroy({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiAgentsToolsRetrieveQueryKey = (
  options: Options<ApiAgentsToolsRetrieveData>
) => createQueryKey('apiAgentsToolsRetrieve', options)

export const apiAgentsToolsRetrieveOptions = (
  options: Options<ApiAgentsToolsRetrieveData>
) =>
  queryOptions<
    ApiAgentsToolsRetrieveResponse,
    AxiosError<DefaultError>,
    ApiAgentsToolsRetrieveResponse,
    ReturnType<typeof apiAgentsToolsRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiAgentsToolsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiAgentsToolsRetrieveQueryKey(options)
  })

export const apiAgentsToolsUpdateMutation = (
  options?: Partial<Options<ApiAgentsToolsUpdateData>>
): UseMutationOptions<
  ApiAgentsToolsUpdateResponse,
  AxiosError<DefaultError>,
  Options<ApiAgentsToolsUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiAgentsToolsUpdateResponse,
    AxiosError<DefaultError>,
    Options<ApiAgentsToolsUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiAgentsToolsUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * `POST /api/agents/scaffold/` — natural-language → Agent draft.
 *
 * Forwards to squad-runtime `/scaffold` and returns the LLM-suggested
 * config as-is. The frontend is responsible for letting the user edit
 * and confirm before we persist anything.
 */
export const apiAgentsScaffoldCreateMutation = (
  options?: Partial<Options<ApiAgentsScaffoldCreateData>>
): UseMutationOptions<
  unknown,
  AxiosError<DefaultError>,
  Options<ApiAgentsScaffoldCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<DefaultError>,
    Options<ApiAgentsScaffoldCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiAgentsScaffoldCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiApprovalsListQueryKey = (
  options?: Options<ApiApprovalsListData>
) => createQueryKey('apiApprovalsList', options)

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiApprovalsListOptions = (
  options?: Options<ApiApprovalsListData>
) =>
  queryOptions<
    ApiApprovalsListResponse,
    AxiosError<DefaultError>,
    ApiApprovalsListResponse,
    ReturnType<typeof apiApprovalsListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiApprovalsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiApprovalsListQueryKey(options)
  })

const createInfiniteParams = <
  K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>
>(
  queryKey: QueryKey<Options>,
  page: K
) => {
  const params = { ...queryKey[0] }
  if (page.body) {
    params.body = {
      ...(queryKey[0].body as any),
      ...(page.body as any)
    }
  }
  if (page.headers) {
    params.headers = {
      ...queryKey[0].headers,
      ...page.headers
    }
  }
  if (page.path) {
    params.path = {
      ...(queryKey[0].path as any),
      ...(page.path as any)
    }
  }
  if (page.query) {
    params.query = {
      ...(queryKey[0].query as any),
      ...(page.query as any)
    }
  }
  return params as unknown as typeof page
}

export const apiApprovalsListInfiniteQueryKey = (
  options?: Options<ApiApprovalsListData>
): QueryKey<Options<ApiApprovalsListData>> =>
  createQueryKey('apiApprovalsList', options, true)

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiApprovalsListInfiniteOptions = (
  options?: Options<ApiApprovalsListData>
) =>
  infiniteQueryOptions<
    ApiApprovalsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<ApiApprovalsListResponse>,
    QueryKey<Options<ApiApprovalsListData>>,
    | number
    | Pick<
        QueryKey<Options<ApiApprovalsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ApiApprovalsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await apiApprovalsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })
        return data
      },
      queryKey: apiApprovalsListInfiniteQueryKey(options)
    }
  )

export const apiApprovalsRetrieveQueryKey = (
  options: Options<ApiApprovalsRetrieveData>
) => createQueryKey('apiApprovalsRetrieve', options)

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiApprovalsRetrieveOptions = (
  options: Options<ApiApprovalsRetrieveData>
) =>
  queryOptions<
    ApiApprovalsRetrieveResponse,
    AxiosError<DefaultError>,
    ApiApprovalsRetrieveResponse,
    ReturnType<typeof apiApprovalsRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiApprovalsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiApprovalsRetrieveQueryKey(options)
  })

export const apiApprovalsPoliciesListQueryKey = (
  options?: Options<ApiApprovalsPoliciesListData>
) => createQueryKey('apiApprovalsPoliciesList', options)

/**
 * Read-only, flat serialization of the policy registry — backs the
 * Approval Policies manifest page.
 */
export const apiApprovalsPoliciesListOptions = (
  options?: Options<ApiApprovalsPoliciesListData>
) =>
  queryOptions<
    ApiApprovalsPoliciesListResponse,
    AxiosError<DefaultError>,
    ApiApprovalsPoliciesListResponse,
    ReturnType<typeof apiApprovalsPoliciesListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiApprovalsPoliciesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiApprovalsPoliciesListQueryKey(options)
  })

export const apiApprovalsStatsRetrieveQueryKey = (
  options?: Options<ApiApprovalsStatsRetrieveData>
) => createQueryKey('apiApprovalsStatsRetrieve', options)

/**
 * Dashboard summary for the Approvals inbox — counts, the caller's
 * personal waiting-on-you/expiring-soon numbers, and 7-day trends.
 */
export const apiApprovalsStatsRetrieveOptions = (
  options?: Options<ApiApprovalsStatsRetrieveData>
) =>
  queryOptions<
    ApiApprovalsStatsRetrieveResponse,
    AxiosError<DefaultError>,
    ApiApprovalsStatsRetrieveResponse,
    ReturnType<typeof apiApprovalsStatsRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiApprovalsStatsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiApprovalsStatsRetrieveQueryKey(options)
  })

export const apiCardPauseRetrieveQueryKey = (
  options?: Options<ApiCardPauseRetrieveData>
) => createQueryKey('apiCardPauseRetrieve', options)

/**
 * `GET/POST /api/card-pause/` — are the agents answering this card?
 *
 * The switch a manager sees in the CRM conversation. It is per card, not per
 * agent: "stop answering this client" means every agent on the card, and a
 * manager should not have to know which one replied last.
 *
 * Reads and writes the same rows the webhook receiver gates on, so the
 * conversation's toggle and a takeover from crm-api cannot disagree.
 */
export const apiCardPauseRetrieveOptions = (
  options?: Options<ApiCardPauseRetrieveData>
) =>
  queryOptions<
    ApiCardPauseRetrieveResponse,
    AxiosError<DefaultError>,
    ApiCardPauseRetrieveResponse,
    ReturnType<typeof apiCardPauseRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiCardPauseRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiCardPauseRetrieveQueryKey(options)
  })

/**
 * `GET/POST /api/card-pause/` — are the agents answering this card?
 *
 * The switch a manager sees in the CRM conversation. It is per card, not per
 * agent: "stop answering this client" means every agent on the card, and a
 * manager should not have to know which one replied last.
 *
 * Reads and writes the same rows the webhook receiver gates on, so the
 * conversation's toggle and a takeover from crm-api cannot disagree.
 */
export const apiCardPauseCreateMutation = (
  options?: Partial<Options<ApiCardPauseCreateData>>
): UseMutationOptions<
  ApiCardPauseCreateResponse,
  AxiosError<DefaultError>,
  Options<ApiCardPauseCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiCardPauseCreateResponse,
    AxiosError<DefaultError>,
    Options<ApiCardPauseCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiCardPauseCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiChannelsListQueryKey = (
  options?: Options<ApiChannelsListData>
) => createQueryKey('apiChannelsList', options)

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiChannelsListOptions = (
  options?: Options<ApiChannelsListData>
) =>
  queryOptions<
    ApiChannelsListResponse,
    AxiosError<DefaultError>,
    ApiChannelsListResponse,
    ReturnType<typeof apiChannelsListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiChannelsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiChannelsListQueryKey(options)
  })

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiChannelsCreateMutation = (
  options?: Partial<Options<ApiChannelsCreateData>>
): UseMutationOptions<
  ApiChannelsCreateResponse,
  AxiosError<DefaultError>,
  Options<ApiChannelsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiChannelsCreateResponse,
    AxiosError<DefaultError>,
    Options<ApiChannelsCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiChannelsCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiChannelsDestroyMutation = (
  options?: Partial<Options<ApiChannelsDestroyData>>
): UseMutationOptions<
  ApiChannelsDestroyResponse,
  AxiosError<DefaultError>,
  Options<ApiChannelsDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiChannelsDestroyResponse,
    AxiosError<DefaultError>,
    Options<ApiChannelsDestroyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiChannelsDestroy({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiChannelsRetrieveQueryKey = (
  options: Options<ApiChannelsRetrieveData>
) => createQueryKey('apiChannelsRetrieve', options)

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiChannelsRetrieveOptions = (
  options: Options<ApiChannelsRetrieveData>
) =>
  queryOptions<
    ApiChannelsRetrieveResponse,
    AxiosError<DefaultError>,
    ApiChannelsRetrieveResponse,
    ReturnType<typeof apiChannelsRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiChannelsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiChannelsRetrieveQueryKey(options)
  })

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiChannelsPartialUpdateMutation = (
  options?: Partial<Options<ApiChannelsPartialUpdateData>>
): UseMutationOptions<
  ApiChannelsPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<ApiChannelsPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiChannelsPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<ApiChannelsPartialUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiChannelsPartialUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiChannelsUpdateMutation = (
  options?: Partial<Options<ApiChannelsUpdateData>>
): UseMutationOptions<
  ApiChannelsUpdateResponse,
  AxiosError<DefaultError>,
  Options<ApiChannelsUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiChannelsUpdateResponse,
    AxiosError<DefaultError>,
    Options<ApiChannelsUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiChannelsUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * GET/PUT/DELETE `/api/channels/<id>/crm-subscription/`.
 *
 * Server-side broker to CRM's `/integrations/squad/config` (the org's single
 * `SquadIntegrationConfig`): resolves the org's CRM app token, forwards the
 * CALLER'S JWT so CRM enforces `configure_integration`, and maps the
 * one-config-per-org constraint into an explicit `current_target` +
 * `force`-guarded overwrite.
 */
export const apiChannelsCrmSubscriptionDestroyMutation = (
  options?: Partial<Options<ApiChannelsCrmSubscriptionDestroyData>>
): UseMutationOptions<
  ApiChannelsCrmSubscriptionDestroyResponse,
  AxiosError<DefaultError>,
  Options<ApiChannelsCrmSubscriptionDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiChannelsCrmSubscriptionDestroyResponse,
    AxiosError<DefaultError>,
    Options<ApiChannelsCrmSubscriptionDestroyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiChannelsCrmSubscriptionDestroy({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiChannelsCrmSubscriptionRetrieveQueryKey = (
  options: Options<ApiChannelsCrmSubscriptionRetrieveData>
) => createQueryKey('apiChannelsCrmSubscriptionRetrieve', options)

/**
 * GET/PUT/DELETE `/api/channels/<id>/crm-subscription/`.
 *
 * Server-side broker to CRM's `/integrations/squad/config` (the org's single
 * `SquadIntegrationConfig`): resolves the org's CRM app token, forwards the
 * CALLER'S JWT so CRM enforces `configure_integration`, and maps the
 * one-config-per-org constraint into an explicit `current_target` +
 * `force`-guarded overwrite.
 */
export const apiChannelsCrmSubscriptionRetrieveOptions = (
  options: Options<ApiChannelsCrmSubscriptionRetrieveData>
) =>
  queryOptions<
    ApiChannelsCrmSubscriptionRetrieveResponse,
    AxiosError<DefaultError>,
    ApiChannelsCrmSubscriptionRetrieveResponse,
    ReturnType<typeof apiChannelsCrmSubscriptionRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiChannelsCrmSubscriptionRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiChannelsCrmSubscriptionRetrieveQueryKey(options)
  })

/**
 * GET/PUT/DELETE `/api/channels/<id>/crm-subscription/`.
 *
 * Server-side broker to CRM's `/integrations/squad/config` (the org's single
 * `SquadIntegrationConfig`): resolves the org's CRM app token, forwards the
 * CALLER'S JWT so CRM enforces `configure_integration`, and maps the
 * one-config-per-org constraint into an explicit `current_target` +
 * `force`-guarded overwrite.
 */
export const apiChannelsCrmSubscriptionUpdateMutation = (
  options?: Partial<Options<ApiChannelsCrmSubscriptionUpdateData>>
): UseMutationOptions<
  ApiChannelsCrmSubscriptionUpdateResponse,
  AxiosError<DefaultError>,
  Options<ApiChannelsCrmSubscriptionUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiChannelsCrmSubscriptionUpdateResponse,
    AxiosError<DefaultError>,
    Options<ApiChannelsCrmSubscriptionUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiChannelsCrmSubscriptionUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiChannelsRotateSecretCreateMutation = (
  options?: Partial<Options<ApiChannelsRotateSecretCreateData>>
): UseMutationOptions<
  ApiChannelsRotateSecretCreateResponse,
  AxiosError<DefaultError>,
  Options<ApiChannelsRotateSecretCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiChannelsRotateSecretCreateResponse,
    AxiosError<DefaultError>,
    Options<ApiChannelsRotateSecretCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiChannelsRotateSecretCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Unauthenticated by SaaS-app-token; auth is the HMAC signature.
 */
export const apiChannelsWebhookCreateMutation = (
  options?: Partial<Options<ApiChannelsWebhookCreateData>>
): UseMutationOptions<
  unknown,
  AxiosError<DefaultError>,
  Options<ApiChannelsWebhookCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<DefaultError>,
    Options<ApiChannelsWebhookCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiChannelsWebhookCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * POST /api/chat/ — creates a run, dispatches it to the worker, tails steps.
 *
 * Execution is owned by the Celery worker (see the RunStep SSE tail note
 * above), NOT this request, so closing the browser tab no longer cancels the
 * run — it keeps going server-side and a returning user sees the rest.
 */
export const apiChatCreateMutation = (
  options?: Partial<Options<ApiChatCreateData>>
): UseMutationOptions<
  unknown,
  AxiosError<DefaultError>,
  Options<ApiChatCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<DefaultError>,
    Options<ApiChatCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiChatCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiChatFilesCreateMutation = (
  options?: Partial<Options<ApiChatFilesCreateData>>
): UseMutationOptions<
  ApiChatFilesCreateResponse,
  AxiosError<DefaultError>,
  Options<ApiChatFilesCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiChatFilesCreateResponse,
    AxiosError<DefaultError>,
    Options<ApiChatFilesCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiChatFilesCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiChatFilesDestroyMutation = (
  options?: Partial<Options<ApiChatFilesDestroyData>>
): UseMutationOptions<
  ApiChatFilesDestroyResponse,
  AxiosError<DefaultError>,
  Options<ApiChatFilesDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiChatFilesDestroyResponse,
    AxiosError<DefaultError>,
    Options<ApiChatFilesDestroyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiChatFilesDestroy({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiChatFilesConfirmCreateMutation = (
  options?: Partial<Options<ApiChatFilesConfirmCreateData>>
): UseMutationOptions<
  ApiChatFilesConfirmCreateResponse,
  AxiosError<DefaultError>,
  Options<ApiChatFilesConfirmCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiChatFilesConfirmCreateResponse,
    AxiosError<DefaultError>,
    Options<ApiChatFilesConfirmCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiChatFilesConfirmCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiChatFilesDownloadRetrieveQueryKey = (
  options: Options<ApiChatFilesDownloadRetrieveData>
) => createQueryKey('apiChatFilesDownloadRetrieve', options)

export const apiChatFilesDownloadRetrieveOptions = (
  options: Options<ApiChatFilesDownloadRetrieveData>
) =>
  queryOptions<
    ApiChatFilesDownloadRetrieveResponse,
    AxiosError<DefaultError>,
    ApiChatFilesDownloadRetrieveResponse,
    ReturnType<typeof apiChatFilesDownloadRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiChatFilesDownloadRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiChatFilesDownloadRetrieveQueryKey(options)
  })

/**
 * POST /api/chat/resume/ — resolves an approval and resumes the run.
 */
export const apiChatResumeCreateMutation = (
  options?: Partial<Options<ApiChatResumeCreateData>>
): UseMutationOptions<
  ApiChatResumeCreateResponse,
  AxiosError<DefaultError>,
  Options<ApiChatResumeCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiChatResumeCreateResponse,
    AxiosError<DefaultError>,
    Options<ApiChatResumeCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiChatResumeCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiMcpCatalogListQueryKey = (
  options?: Options<ApiMcpCatalogListData>
) => createQueryKey('apiMcpCatalogList', options)

/**
 * `/api/mcp-catalog/` — public list of preset MCP servers + connect/disconnect.
 *
 * Catalog itself is system-wide (no per-workspace rows); the `is_connected`
 * flag on each entry tells the FE whether the current workspace has
 * already provisioned a `McpServer` from it.
 */
export const apiMcpCatalogListOptions = (
  options?: Options<ApiMcpCatalogListData>
) =>
  queryOptions<
    ApiMcpCatalogListResponse,
    AxiosError<DefaultError>,
    ApiMcpCatalogListResponse,
    ReturnType<typeof apiMcpCatalogListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiMcpCatalogList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiMcpCatalogListQueryKey(options)
  })

/**
 * `/api/mcp-catalog/` — public list of preset MCP servers + connect/disconnect.
 *
 * Catalog itself is system-wide (no per-workspace rows); the `is_connected`
 * flag on each entry tells the FE whether the current workspace has
 * already provisioned a `McpServer` from it.
 */
export const apiMcpCatalogConnectCreateMutation = (
  options?: Partial<Options<ApiMcpCatalogConnectCreateData>>
): UseMutationOptions<
  ApiMcpCatalogConnectCreateResponse,
  AxiosError<DefaultError>,
  Options<ApiMcpCatalogConnectCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiMcpCatalogConnectCreateResponse,
    AxiosError<DefaultError>,
    Options<ApiMcpCatalogConnectCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiMcpCatalogConnectCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * `/api/mcp-catalog/` — public list of preset MCP servers + connect/disconnect.
 *
 * Catalog itself is system-wide (no per-workspace rows); the `is_connected`
 * flag on each entry tells the FE whether the current workspace has
 * already provisioned a `McpServer` from it.
 */
export const apiMcpCatalogDisconnectCreateMutation = (
  options?: Partial<Options<ApiMcpCatalogDisconnectCreateData>>
): UseMutationOptions<
  ApiMcpCatalogDisconnectCreateResponse,
  AxiosError<DefaultError>,
  Options<ApiMcpCatalogDisconnectCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiMcpCatalogDisconnectCreateResponse,
    AxiosError<DefaultError>,
    Options<ApiMcpCatalogDisconnectCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiMcpCatalogDisconnectCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiMcpCatalogToolsListQueryKey = (
  options?: Options<ApiMcpCatalogToolsListData>
) => createQueryKey('apiMcpCatalogToolsList', options)

/**
 * Every known MCP tool, tagged with its `application` — global,
 * not scoped to the current workspace, so the FE can build a static
 * `(application, tool_name) -> translation` map ahead of time (same
 * idea as `Agent.application`, but for tools).
 *
 * Tool names are never persisted — they're only discoverable live via
 * `squad-runtime` connecting to each MCP server. Redis-cached for 10
 * minutes (`?refresh=1` bypasses); on an unreachable/misbehaving
 * runtime this falls back to the last-good cache, then finally an
 * empty list — this endpoint must never 5xx just because a docs
 * consumer asked at the wrong moment.
 */
export const apiMcpCatalogToolsListOptions = (
  options?: Options<ApiMcpCatalogToolsListData>
) =>
  queryOptions<
    ApiMcpCatalogToolsListResponse,
    AxiosError<DefaultError>,
    ApiMcpCatalogToolsListResponse,
    ReturnType<typeof apiMcpCatalogToolsListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiMcpCatalogToolsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiMcpCatalogToolsListQueryKey(options)
  })

export const apiMcpServersListQueryKey = (
  options?: Options<ApiMcpServersListData>
) => createQueryKey('apiMcpServersList', options)

export const apiMcpServersListOptions = (
  options?: Options<ApiMcpServersListData>
) =>
  queryOptions<
    ApiMcpServersListResponse,
    AxiosError<DefaultError>,
    ApiMcpServersListResponse,
    ReturnType<typeof apiMcpServersListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiMcpServersList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiMcpServersListQueryKey(options)
  })

export const apiMcpServersCreateMutation = (
  options?: Partial<Options<ApiMcpServersCreateData>>
): UseMutationOptions<
  ApiMcpServersCreateResponse,
  AxiosError<DefaultError>,
  Options<ApiMcpServersCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiMcpServersCreateResponse,
    AxiosError<DefaultError>,
    Options<ApiMcpServersCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiMcpServersCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiMcpServersDestroyMutation = (
  options?: Partial<Options<ApiMcpServersDestroyData>>
): UseMutationOptions<
  ApiMcpServersDestroyResponse,
  AxiosError<DefaultError>,
  Options<ApiMcpServersDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiMcpServersDestroyResponse,
    AxiosError<DefaultError>,
    Options<ApiMcpServersDestroyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiMcpServersDestroy({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiMcpServersRetrieveQueryKey = (
  options: Options<ApiMcpServersRetrieveData>
) => createQueryKey('apiMcpServersRetrieve', options)

export const apiMcpServersRetrieveOptions = (
  options: Options<ApiMcpServersRetrieveData>
) =>
  queryOptions<
    ApiMcpServersRetrieveResponse,
    AxiosError<DefaultError>,
    ApiMcpServersRetrieveResponse,
    ReturnType<typeof apiMcpServersRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiMcpServersRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiMcpServersRetrieveQueryKey(options)
  })

export const apiMcpServersPartialUpdateMutation = (
  options?: Partial<Options<ApiMcpServersPartialUpdateData>>
): UseMutationOptions<
  ApiMcpServersPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<ApiMcpServersPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiMcpServersPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<ApiMcpServersPartialUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiMcpServersPartialUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiMcpServersUpdateMutation = (
  options?: Partial<Options<ApiMcpServersUpdateData>>
): UseMutationOptions<
  ApiMcpServersUpdateResponse,
  AxiosError<DefaultError>,
  Options<ApiMcpServersUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiMcpServersUpdateResponse,
    AxiosError<DefaultError>,
    Options<ApiMcpServersUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiMcpServersUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiMcpServersOauthRetrieveQueryKey = (
  options: Options<ApiMcpServersOauthRetrieveData>
) => createQueryKey('apiMcpServersOauthRetrieve', options)

/**
 * Whether this server wants OAuth, and whether we hold a token.
 *
 * Probes live the first time (and on `?refresh=1`); afterwards the answer
 * comes off the row. An unreachable endpoint is reported as `unknown`
 * plus `last_error` — a transient outage must not read as "no auth
 * needed" and silently strip a working connection's badge.
 */
export const apiMcpServersOauthRetrieveOptions = (
  options: Options<ApiMcpServersOauthRetrieveData>
) =>
  queryOptions<
    ApiMcpServersOauthRetrieveResponse,
    AxiosError<DefaultError>,
    ApiMcpServersOauthRetrieveResponse,
    ReturnType<typeof apiMcpServersOauthRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiMcpServersOauthRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiMcpServersOauthRetrieveQueryKey(options)
  })

/**
 * Forget the tokens and the client registration for this server.
 */
export const apiMcpServersOauthDisconnectCreateMutation = (
  options?: Partial<Options<ApiMcpServersOauthDisconnectCreateData>>
): UseMutationOptions<
  ApiMcpServersOauthDisconnectCreateResponse,
  AxiosError<DefaultError>,
  Options<ApiMcpServersOauthDisconnectCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiMcpServersOauthDisconnectCreateResponse,
    AxiosError<DefaultError>,
    Options<ApiMcpServersOauthDisconnectCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiMcpServersOauthDisconnectCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Discover + register (once) and hand the FE a consent URL.
 */
export const apiMcpServersOauthStartCreateMutation = (
  options?: Partial<Options<ApiMcpServersOauthStartCreateData>>
): UseMutationOptions<
  ApiMcpServersOauthStartCreateResponse,
  AxiosError<DefaultError>,
  Options<ApiMcpServersOauthStartCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiMcpServersOauthStartCreateResponse,
    AxiosError<DefaultError>,
    Options<ApiMcpServersOauthStartCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiMcpServersOauthStartCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiMcpOauthCallbackRetrieveQueryKey = (
  options?: Options<ApiMcpOauthCallbackRetrieveData>
) => createQueryKey('apiMcpOauthCallbackRetrieve', options)

/**
 * `/api/mcp/oauth/callback/` — public, reached by the user's browser
 * straight from the MCP server's authorization server.
 *
 * No SAAS-APP-TOKEN or JWT is present on this hop, so the `state` row
 * created by `oauth_start` is the only thing that says which server (and
 * workspace) the code belongs to — same contract as the Microsoft Graph
 * callback. Errors always redirect back to the FE with a readable reason
 * rather than rendering a bare DRF error page at an API URL.
 */
export const apiMcpOauthCallbackRetrieveOptions = (
  options?: Options<ApiMcpOauthCallbackRetrieveData>
) =>
  queryOptions<
    unknown,
    AxiosError<DefaultError>,
    unknown,
    ReturnType<typeof apiMcpOauthCallbackRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiMcpOauthCallbackRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiMcpOauthCallbackRetrieveQueryKey(options)
  })

export const apiMeRetrieveQueryKey = (options?: Options<ApiMeRetrieveData>) =>
  createQueryKey('apiMeRetrieve', options)

export const apiMeRetrieveOptions = (options?: Options<ApiMeRetrieveData>) =>
  queryOptions<
    ApiMeRetrieveResponse,
    AxiosError<DefaultError>,
    ApiMeRetrieveResponse,
    ReturnType<typeof apiMeRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiMeRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiMeRetrieveQueryKey(options)
  })

export const apiMicrosoftGraphAdminConsentCallbackRetrieveQueryKey = (
  options?: Options<ApiMicrosoftGraphAdminConsentCallbackRetrieveData>
) => createQueryKey('apiMicrosoftGraphAdminConsentCallbackRetrieve', options)

/**
 * Public — reached by the admin's browser directly from Microsoft. No
 * `code` here (this is a boolean admin-consent confirmation, not an
 * authorization-code exchange).
 */
export const apiMicrosoftGraphAdminConsentCallbackRetrieveOptions = (
  options?: Options<ApiMicrosoftGraphAdminConsentCallbackRetrieveData>
) =>
  queryOptions<
    unknown,
    AxiosError<DefaultError>,
    unknown,
    ReturnType<typeof apiMicrosoftGraphAdminConsentCallbackRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiMicrosoftGraphAdminConsentCallbackRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiMicrosoftGraphAdminConsentCallbackRetrieveQueryKey(options)
  })

/**
 * Admin-only: deactivate SharePoint for this workspace. Deletes the
 * local consent record — this doesn't call Microsoft to rescind the
 * tenant-side admin consent (would need elevated Graph permissions this
 * app doesn't request), but via `_org_activated` it immediately cuts off
 * every delegated per-user connection. An admin can reactivate by granting
 * again.
 */
export const apiMicrosoftGraphAdminConsentRevokeCreateMutation = (
  options?: Partial<Options<ApiMicrosoftGraphAdminConsentRevokeCreateData>>
): UseMutationOptions<
  ApiMicrosoftGraphAdminConsentRevokeCreateResponse,
  AxiosError<DefaultError>,
  Options<ApiMicrosoftGraphAdminConsentRevokeCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiMicrosoftGraphAdminConsentRevokeCreateResponse,
    AxiosError<DefaultError>,
    Options<ApiMicrosoftGraphAdminConsentRevokeCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiMicrosoftGraphAdminConsentRevokeCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiMicrosoftGraphAdminConsentStartCreateMutation = (
  options?: Partial<Options<ApiMicrosoftGraphAdminConsentStartCreateData>>
): UseMutationOptions<
  ApiMicrosoftGraphAdminConsentStartCreateResponse,
  AxiosError<DefaultError>,
  Options<ApiMicrosoftGraphAdminConsentStartCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiMicrosoftGraphAdminConsentStartCreateResponse,
    AxiosError<DefaultError>,
    Options<ApiMicrosoftGraphAdminConsentStartCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiMicrosoftGraphAdminConsentStartCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiMicrosoftGraphAdminConsentStatusRetrieveQueryKey = (
  options?: Options<ApiMicrosoftGraphAdminConsentStatusRetrieveData>
) => createQueryKey('apiMicrosoftGraphAdminConsentStatusRetrieve', options)

export const apiMicrosoftGraphAdminConsentStatusRetrieveOptions = (
  options?: Options<ApiMicrosoftGraphAdminConsentStatusRetrieveData>
) =>
  queryOptions<
    ApiMicrosoftGraphAdminConsentStatusRetrieveResponse,
    AxiosError<DefaultError>,
    ApiMicrosoftGraphAdminConsentStatusRetrieveResponse,
    ReturnType<typeof apiMicrosoftGraphAdminConsentStatusRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiMicrosoftGraphAdminConsentStatusRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiMicrosoftGraphAdminConsentStatusRetrieveQueryKey(options)
  })

export const apiMicrosoftGraphBrowseDrivesChildrenRetrieveQueryKey = (
  options: Options<ApiMicrosoftGraphBrowseDrivesChildrenRetrieveData>
) => createQueryKey('apiMicrosoftGraphBrowseDrivesChildrenRetrieve', options)

/**
 * `GET /api/microsoft-graph/browse/drives/<drive_id>/children/` — root when
 * no `item_id` is given.
 */
export const apiMicrosoftGraphBrowseDrivesChildrenRetrieveOptions = (
  options: Options<ApiMicrosoftGraphBrowseDrivesChildrenRetrieveData>
) =>
  queryOptions<
    ApiMicrosoftGraphBrowseDrivesChildrenRetrieveResponse,
    AxiosError<DefaultError>,
    ApiMicrosoftGraphBrowseDrivesChildrenRetrieveResponse,
    ReturnType<typeof apiMicrosoftGraphBrowseDrivesChildrenRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiMicrosoftGraphBrowseDrivesChildrenRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiMicrosoftGraphBrowseDrivesChildrenRetrieveQueryKey(options)
  })

export const apiMicrosoftGraphBrowseDrivesSearchRetrieveQueryKey = (
  options: Options<ApiMicrosoftGraphBrowseDrivesSearchRetrieveData>
) => createQueryKey('apiMicrosoftGraphBrowseDrivesSearchRetrieve', options)

/**
 * `GET /api/microsoft-graph/browse/drives/<drive_id>/search/?q=`.
 */
export const apiMicrosoftGraphBrowseDrivesSearchRetrieveOptions = (
  options: Options<ApiMicrosoftGraphBrowseDrivesSearchRetrieveData>
) =>
  queryOptions<
    ApiMicrosoftGraphBrowseDrivesSearchRetrieveResponse,
    AxiosError<DefaultError>,
    ApiMicrosoftGraphBrowseDrivesSearchRetrieveResponse,
    ReturnType<typeof apiMicrosoftGraphBrowseDrivesSearchRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiMicrosoftGraphBrowseDrivesSearchRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiMicrosoftGraphBrowseDrivesSearchRetrieveQueryKey(options)
  })

export const apiMicrosoftGraphBrowseSitesRetrieveQueryKey = (
  options?: Options<ApiMicrosoftGraphBrowseSitesRetrieveData>
) => createQueryKey('apiMicrosoftGraphBrowseSitesRetrieve', options)

/**
 * `GET /api/microsoft-graph/browse/sites/` — sites the caller can see.
 *
 * Only `/sites` is listed, which is what keeps personal OneDrive out of the
 * picker by construction even though the delegated grant would reach it.
 */
export const apiMicrosoftGraphBrowseSitesRetrieveOptions = (
  options?: Options<ApiMicrosoftGraphBrowseSitesRetrieveData>
) =>
  queryOptions<
    ApiMicrosoftGraphBrowseSitesRetrieveResponse,
    AxiosError<DefaultError>,
    ApiMicrosoftGraphBrowseSitesRetrieveResponse,
    ReturnType<typeof apiMicrosoftGraphBrowseSitesRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiMicrosoftGraphBrowseSitesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiMicrosoftGraphBrowseSitesRetrieveQueryKey(options)
  })

export const apiMicrosoftGraphBrowseSitesDrivesRetrieveQueryKey = (
  options: Options<ApiMicrosoftGraphBrowseSitesDrivesRetrieveData>
) => createQueryKey('apiMicrosoftGraphBrowseSitesDrivesRetrieve', options)

/**
 * `GET /api/microsoft-graph/browse/sites/<site_id>/drives/`.
 */
export const apiMicrosoftGraphBrowseSitesDrivesRetrieveOptions = (
  options: Options<ApiMicrosoftGraphBrowseSitesDrivesRetrieveData>
) =>
  queryOptions<
    ApiMicrosoftGraphBrowseSitesDrivesRetrieveResponse,
    AxiosError<DefaultError>,
    ApiMicrosoftGraphBrowseSitesDrivesRetrieveResponse,
    ReturnType<typeof apiMicrosoftGraphBrowseSitesDrivesRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiMicrosoftGraphBrowseSitesDrivesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiMicrosoftGraphBrowseSitesDrivesRetrieveQueryKey(options)
  })

export const apiMicrosoftGraphConnectCallbackRetrieveQueryKey = (
  options?: Options<ApiMicrosoftGraphConnectCallbackRetrieveData>
) => createQueryKey('apiMicrosoftGraphConnectCallbackRetrieve', options)

/**
 * Public — reached by the user's browser directly from Microsoft.
 */
export const apiMicrosoftGraphConnectCallbackRetrieveOptions = (
  options?: Options<ApiMicrosoftGraphConnectCallbackRetrieveData>
) =>
  queryOptions<
    unknown,
    AxiosError<DefaultError>,
    unknown,
    ReturnType<typeof apiMicrosoftGraphConnectCallbackRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiMicrosoftGraphConnectCallbackRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiMicrosoftGraphConnectCallbackRetrieveQueryKey(options)
  })

export const apiMicrosoftGraphConnectStartCreateMutation = (
  options?: Partial<Options<ApiMicrosoftGraphConnectStartCreateData>>
): UseMutationOptions<
  ApiMicrosoftGraphConnectStartCreateResponse,
  AxiosError<DefaultError>,
  Options<ApiMicrosoftGraphConnectStartCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiMicrosoftGraphConnectStartCreateResponse,
    AxiosError<DefaultError>,
    Options<ApiMicrosoftGraphConnectStartCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiMicrosoftGraphConnectStartCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiMicrosoftGraphDisconnectCreateMutation = (
  options?: Partial<Options<ApiMicrosoftGraphDisconnectCreateData>>
): UseMutationOptions<
  ApiMicrosoftGraphDisconnectCreateResponse,
  AxiosError<DefaultError>,
  Options<ApiMicrosoftGraphDisconnectCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiMicrosoftGraphDisconnectCreateResponse,
    AxiosError<DefaultError>,
    Options<ApiMicrosoftGraphDisconnectCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiMicrosoftGraphDisconnectCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiMicrosoftGraphStatusRetrieveQueryKey = (
  options?: Options<ApiMicrosoftGraphStatusRetrieveData>
) => createQueryKey('apiMicrosoftGraphStatusRetrieve', options)

export const apiMicrosoftGraphStatusRetrieveOptions = (
  options?: Options<ApiMicrosoftGraphStatusRetrieveData>
) =>
  queryOptions<
    ApiMicrosoftGraphStatusRetrieveResponse,
    AxiosError<DefaultError>,
    ApiMicrosoftGraphStatusRetrieveResponse,
    ReturnType<typeof apiMicrosoftGraphStatusRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiMicrosoftGraphStatusRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiMicrosoftGraphStatusRetrieveQueryKey(options)
  })

export const apiObservabilityFeedbackRetrieveQueryKey = (
  options?: Options<ApiObservabilityFeedbackRetrieveData>
) => createQueryKey('apiObservabilityFeedbackRetrieve', options)

/**
 * This project's 👍/👎 ratings: a tally plus the rated traces. We pull only
 * the traces that carry a "User feedback" score (Opik feedback filter), so this
 * is cheap regardless of total volume — and reliable, unlike `projects/stats`,
 * which aggregates feedback lazily.
 */
export const apiObservabilityFeedbackRetrieveOptions = (
  options?: Options<ApiObservabilityFeedbackRetrieveData>
) =>
  queryOptions<
    unknown,
    AxiosError<DefaultError>,
    unknown,
    ReturnType<typeof apiObservabilityFeedbackRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiObservabilityFeedbackRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiObservabilityFeedbackRetrieveQueryKey(options)
  })

export const apiObservabilityMetricsRetrieveQueryKey = (
  options?: Options<ApiObservabilityMetricsRetrieveData>
) => createQueryKey('apiObservabilityMetricsRetrieve', options)

/**
 * Time-series for a single `metric_type` (chart). FE calls once per chart.
 */
export const apiObservabilityMetricsRetrieveOptions = (
  options?: Options<ApiObservabilityMetricsRetrieveData>
) =>
  queryOptions<
    unknown,
    AxiosError<DefaultError>,
    unknown,
    ReturnType<typeof apiObservabilityMetricsRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiObservabilityMetricsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiObservabilityMetricsRetrieveQueryKey(options)
  })

export const apiObservabilityModelsRetrieveQueryKey = (
  options?: Options<ApiObservabilityModelsRetrieveData>
) => createQueryKey('apiObservabilityModelsRetrieve', options)

/**
 * Per-model breakdown for this project — calls / tokens / est. cost,
 * aggregated from LLM spans (model is a span attribute, not on traces). Also
 * powers the Traces tab's model dropdown. Bounded to the most-recent N spans.
 */
export const apiObservabilityModelsRetrieveOptions = (
  options?: Options<ApiObservabilityModelsRetrieveData>
) =>
  queryOptions<
    unknown,
    AxiosError<DefaultError>,
    unknown,
    ReturnType<typeof apiObservabilityModelsRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiObservabilityModelsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiObservabilityModelsRetrieveQueryKey(options)
  })

/**
 * Rate a chat turn 👍/👎 by its Squad `run_id` (used by the chat UI). The
 * run's trace is resolved via `metadata.run_id` within the caller's locked
 * project, so a run from another tenant — or one with no trace — 404s.
 */
export const apiObservabilityRunsFeedbackDestroyMutation = (
  options?: Partial<Options<ApiObservabilityRunsFeedbackDestroyData>>
): UseMutationOptions<
  ApiObservabilityRunsFeedbackDestroyResponse,
  AxiosError<DefaultError>,
  Options<ApiObservabilityRunsFeedbackDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiObservabilityRunsFeedbackDestroyResponse,
    AxiosError<DefaultError>,
    Options<ApiObservabilityRunsFeedbackDestroyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiObservabilityRunsFeedbackDestroy({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Body: {"up": true|false}.
 */
export const apiObservabilityRunsFeedbackUpdateMutation = (
  options?: Partial<Options<ApiObservabilityRunsFeedbackUpdateData>>
): UseMutationOptions<
  unknown,
  AxiosError<DefaultError>,
  Options<ApiObservabilityRunsFeedbackUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<DefaultError>,
    Options<ApiObservabilityRunsFeedbackUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiObservabilityRunsFeedbackUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiObservabilitySummaryRetrieveQueryKey = (
  options?: Options<ApiObservabilitySummaryRetrieveData>
) => createQueryKey('apiObservabilitySummaryRetrieve', options)

/**
 * KPI header for the dashboard — project-level aggregates (cost, duration
 * percentiles, token totals, feedback) from Opik's `projects/stats`.
 */
export const apiObservabilitySummaryRetrieveOptions = (
  options?: Options<ApiObservabilitySummaryRetrieveData>
) =>
  queryOptions<
    unknown,
    AxiosError<DefaultError>,
    unknown,
    ReturnType<typeof apiObservabilitySummaryRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiObservabilitySummaryRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiObservabilitySummaryRetrieveQueryKey(options)
  })

export const apiObservabilityThreadsRetrieveQueryKey = (
  options?: Options<ApiObservabilityThreadsRetrieveData>
) => createQueryKey('apiObservabilityThreadsRetrieve', options)

/**
 * Paginated conversation threads — project locked.
 */
export const apiObservabilityThreadsRetrieveOptions = (
  options?: Options<ApiObservabilityThreadsRetrieveData>
) =>
  queryOptions<
    unknown,
    AxiosError<DefaultError>,
    unknown,
    ReturnType<typeof apiObservabilityThreadsRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiObservabilityThreadsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiObservabilityThreadsRetrieveQueryKey(options)
  })

export const apiObservabilityThreadsRetrieveInfiniteQueryKey = (
  options?: Options<ApiObservabilityThreadsRetrieveData>
): QueryKey<Options<ApiObservabilityThreadsRetrieveData>> =>
  createQueryKey('apiObservabilityThreadsRetrieve', options, true)

/**
 * Paginated conversation threads — project locked.
 */
export const apiObservabilityThreadsRetrieveInfiniteOptions = (
  options?: Options<ApiObservabilityThreadsRetrieveData>
) =>
  infiniteQueryOptions<
    unknown,
    AxiosError<DefaultError>,
    InfiniteData<unknown>,
    QueryKey<Options<ApiObservabilityThreadsRetrieveData>>,
    | number
    | Pick<
        QueryKey<Options<ApiObservabilityThreadsRetrieveData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ApiObservabilityThreadsRetrieveData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await apiObservabilityThreadsRetrieve({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })
        return data
      },
      queryKey: apiObservabilityThreadsRetrieveInfiniteQueryKey(options)
    }
  )

export const apiObservabilityThreadsRatingsRetrieveQueryKey = (
  options: Options<ApiObservabilityThreadsRatingsRetrieveData>
) => createQueryKey('apiObservabilityThreadsRatingsRetrieve', options)

/**
 * Per-run 👍/👎 ratings for one chat thread, so the chat can render each
 * turn's current rating in one call. Keyed by the `run_id` stamped into trace
 * metadata; turns traced before run_id tagging shipped simply don't appear.
 */
export const apiObservabilityThreadsRatingsRetrieveOptions = (
  options: Options<ApiObservabilityThreadsRatingsRetrieveData>
) =>
  queryOptions<
    unknown,
    AxiosError<DefaultError>,
    unknown,
    ReturnType<typeof apiObservabilityThreadsRatingsRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiObservabilityThreadsRatingsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiObservabilityThreadsRatingsRetrieveQueryKey(options)
  })

export const apiObservabilityTracesRetrieveQueryKey = (
  options?: Options<ApiObservabilityTracesRetrieveData>
) => createQueryKey('apiObservabilityTracesRetrieve', options)

/**
 * Paginated trace list — project locked via `project_name`. An optional
 * `thread_id` narrows to one conversation thread (used by the Threads drawer);
 * it's applied via Opik's trace filter, still within the locked project.
 */
export const apiObservabilityTracesRetrieveOptions = (
  options?: Options<ApiObservabilityTracesRetrieveData>
) =>
  queryOptions<
    unknown,
    AxiosError<DefaultError>,
    unknown,
    ReturnType<typeof apiObservabilityTracesRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiObservabilityTracesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiObservabilityTracesRetrieveQueryKey(options)
  })

export const apiObservabilityTracesRetrieveInfiniteQueryKey = (
  options?: Options<ApiObservabilityTracesRetrieveData>
): QueryKey<Options<ApiObservabilityTracesRetrieveData>> =>
  createQueryKey('apiObservabilityTracesRetrieve', options, true)

/**
 * Paginated trace list — project locked via `project_name`. An optional
 * `thread_id` narrows to one conversation thread (used by the Threads drawer);
 * it's applied via Opik's trace filter, still within the locked project.
 */
export const apiObservabilityTracesRetrieveInfiniteOptions = (
  options?: Options<ApiObservabilityTracesRetrieveData>
) =>
  infiniteQueryOptions<
    unknown,
    AxiosError<DefaultError>,
    InfiniteData<unknown>,
    QueryKey<Options<ApiObservabilityTracesRetrieveData>>,
    | number
    | Pick<
        QueryKey<Options<ApiObservabilityTracesRetrieveData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ApiObservabilityTracesRetrieveData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await apiObservabilityTracesRetrieve({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })
        return data
      },
      queryKey: apiObservabilityTracesRetrieveInfiniteQueryKey(options)
    }
  )

export const apiObservabilityTracesRetrieve2QueryKey = (
  options: Options<ApiObservabilityTracesRetrieve2Data>
) => createQueryKey('apiObservabilityTracesRetrieve2', options)

/**
 * One trace + its span tree. Verifies the trace belongs to THIS account's
 * project before returning anything (tenant isolation on an unauthed Opik).
 */
export const apiObservabilityTracesRetrieve2Options = (
  options: Options<ApiObservabilityTracesRetrieve2Data>
) =>
  queryOptions<
    unknown,
    AxiosError<DefaultError>,
    unknown,
    ReturnType<typeof apiObservabilityTracesRetrieve2QueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiObservabilityTracesRetrieve2({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiObservabilityTracesRetrieve2QueryKey(options)
  })

/**
 * Clear the rating.
 */
export const apiObservabilityTracesFeedbackDestroyMutation = (
  options?: Partial<Options<ApiObservabilityTracesFeedbackDestroyData>>
): UseMutationOptions<
  ApiObservabilityTracesFeedbackDestroyResponse,
  AxiosError<DefaultError>,
  Options<ApiObservabilityTracesFeedbackDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiObservabilityTracesFeedbackDestroyResponse,
    AxiosError<DefaultError>,
    Options<ApiObservabilityTracesFeedbackDestroyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiObservabilityTracesFeedbackDestroy({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Set the rating. Body: {"up": true|false}.
 */
export const apiObservabilityTracesFeedbackUpdateMutation = (
  options?: Partial<Options<ApiObservabilityTracesFeedbackUpdateData>>
): UseMutationOptions<
  unknown,
  AxiosError<DefaultError>,
  Options<ApiObservabilityTracesFeedbackUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<DefaultError>,
    Options<ApiObservabilityTracesFeedbackUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiObservabilityTracesFeedbackUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiProvidersRetrieveQueryKey = (
  options?: Options<ApiProvidersRetrieveData>
) => createQueryKey('apiProvidersRetrieve', options)

export const apiProvidersRetrieveOptions = (
  options?: Options<ApiProvidersRetrieveData>
) =>
  queryOptions<
    unknown,
    AxiosError<DefaultError>,
    unknown,
    ReturnType<typeof apiProvidersRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiProvidersRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiProvidersRetrieveQueryKey(options)
  })

export const apiProvidersModelsRetrieveQueryKey = (
  options: Options<ApiProvidersModelsRetrieveData>
) => createQueryKey('apiProvidersModelsRetrieve', options)

export const apiProvidersModelsRetrieveOptions = (
  options: Options<ApiProvidersModelsRetrieveData>
) =>
  queryOptions<
    unknown,
    AxiosError<DefaultError>,
    unknown,
    ReturnType<typeof apiProvidersModelsRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiProvidersModelsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiProvidersModelsRetrieveQueryKey(options)
  })

export const apiRunsListQueryKey = (options?: Options<ApiRunsListData>) =>
  createQueryKey('apiRunsList', options)

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiRunsListOptions = (options?: Options<ApiRunsListData>) =>
  queryOptions<
    ApiRunsListResponse,
    AxiosError<DefaultError>,
    ApiRunsListResponse,
    ReturnType<typeof apiRunsListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiRunsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiRunsListQueryKey(options)
  })

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiRunsDestroyMutation = (
  options?: Partial<Options<ApiRunsDestroyData>>
): UseMutationOptions<
  ApiRunsDestroyResponse,
  AxiosError<DefaultError>,
  Options<ApiRunsDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiRunsDestroyResponse,
    AxiosError<DefaultError>,
    Options<ApiRunsDestroyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiRunsDestroy({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiRunsRetrieveQueryKey = (
  options: Options<ApiRunsRetrieveData>
) => createQueryKey('apiRunsRetrieve', options)

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiRunsRetrieveOptions = (options: Options<ApiRunsRetrieveData>) =>
  queryOptions<
    ApiRunsRetrieveResponse,
    AxiosError<DefaultError>,
    ApiRunsRetrieveResponse,
    ReturnType<typeof apiRunsRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiRunsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiRunsRetrieveQueryKey(options)
  })

/**
 * Mark an in-flight run as ERROR so polling clients stop spinning.
 *
 * We can't actually interrupt the upstream runtime worker from here
 * (it owns its own process and SSE socket), but flipping the status
 * to ERROR is enough for the FE: the `/messages/` endpoint stops
 * reporting it as `active_run`, polling stops, and any later events
 * from a zombie worker will be discarded — token rows still land in
 * the run's `steps` for audit but the UI no longer treats the run
 * as alive.
 *
 * DONE / ERROR runs are returned unchanged so a duplicate Stop click
 * (or a race with the janitor) is idempotent. PAUSED runs are
 * cancellable: a user explicitly abandoning an approval should mean
 * the run is over, not stuck waiting forever.
 */
export const apiRunsCancelCreateMutation = (
  options?: Partial<Options<ApiRunsCancelCreateData>>
): UseMutationOptions<
  ApiRunsCancelCreateResponse,
  AxiosError<DefaultError>,
  Options<ApiRunsCancelCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiRunsCancelCreateResponse,
    AxiosError<DefaultError>,
    Options<ApiRunsCancelCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiRunsCancelCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiRunsStepsListQueryKey = (
  options: Options<ApiRunsStepsListData>
) => createQueryKey('apiRunsStepsList', options)

/**
 * `GET /api/runs/<run_id>/steps/` — full timeline for the trace viewer.
 */
export const apiRunsStepsListOptions = (
  options: Options<ApiRunsStepsListData>
) =>
  queryOptions<
    ApiRunsStepsListResponse,
    AxiosError<DefaultError>,
    ApiRunsStepsListResponse,
    ReturnType<typeof apiRunsStepsListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiRunsStepsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiRunsStepsListQueryKey(options)
  })

export const apiRunsStreamRetrieveQueryKey = (
  options: Options<ApiRunsStreamRetrieveData>
) => createQueryKey('apiRunsStreamRetrieve', options)

/**
 * `GET /api/runs/<run_id>/stream/` — reattach to a run's live SSE tail
 * after a client disconnected (tab close/reload, transport drop), without
 * starting a new run.
 *
 * Execution is worker-owned (see `ChatStreamView`), so the run keeps going
 * regardless of who's tailing it — this just opens another `_tail_run_steps`
 * generator against the same `RunStep` rows. `?since=<step_index>` (default
 * 0) skips steps the caller already has; pass the count from
 * `/api/runs/<run_id>/steps/` to resume without duplicates. If the run has
 * already reached a terminal status, the tail emits the closing event
 * immediately instead of waiting out the idle timeout.
 */
export const apiRunsStreamRetrieveOptions = (
  options: Options<ApiRunsStreamRetrieveData>
) =>
  queryOptions<
    unknown,
    AxiosError<DefaultError>,
    unknown,
    ReturnType<typeof apiRunsStreamRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiRunsStreamRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiRunsStreamRetrieveQueryKey(options)
  })

/**
 * Bulk-delete runs that match the same filters as `list`.
 *
 * Used by the Inbox UI's "Clear" button. The destructive scope is
 * the same query string the FE just listed against — so `?trigger=
 * schedule&status=done` clears only successful scheduled runs.
 */
export const apiRunsClearDestroyMutation = (
  options?: Partial<Options<ApiRunsClearDestroyData>>
): UseMutationOptions<
  ApiRunsClearDestroyResponse,
  AxiosError<DefaultError>,
  Options<ApiRunsClearDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiRunsClearDestroyResponse,
    AxiosError<DefaultError>,
    Options<ApiRunsClearDestroyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiRunsClearDestroy({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiSchedulesListQueryKey = (
  options?: Options<ApiSchedulesListData>
) => createQueryKey('apiSchedulesList', options)

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiSchedulesListOptions = (
  options?: Options<ApiSchedulesListData>
) =>
  queryOptions<
    ApiSchedulesListResponse,
    AxiosError<DefaultError>,
    ApiSchedulesListResponse,
    ReturnType<typeof apiSchedulesListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiSchedulesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiSchedulesListQueryKey(options)
  })

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiSchedulesCreateMutation = (
  options?: Partial<Options<ApiSchedulesCreateData>>
): UseMutationOptions<
  ApiSchedulesCreateResponse,
  AxiosError<DefaultError>,
  Options<ApiSchedulesCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiSchedulesCreateResponse,
    AxiosError<DefaultError>,
    Options<ApiSchedulesCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiSchedulesCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiSchedulesDestroyMutation = (
  options?: Partial<Options<ApiSchedulesDestroyData>>
): UseMutationOptions<
  ApiSchedulesDestroyResponse,
  AxiosError<DefaultError>,
  Options<ApiSchedulesDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiSchedulesDestroyResponse,
    AxiosError<DefaultError>,
    Options<ApiSchedulesDestroyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiSchedulesDestroy({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiSchedulesRetrieveQueryKey = (
  options: Options<ApiSchedulesRetrieveData>
) => createQueryKey('apiSchedulesRetrieve', options)

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiSchedulesRetrieveOptions = (
  options: Options<ApiSchedulesRetrieveData>
) =>
  queryOptions<
    ApiSchedulesRetrieveResponse,
    AxiosError<DefaultError>,
    ApiSchedulesRetrieveResponse,
    ReturnType<typeof apiSchedulesRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiSchedulesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiSchedulesRetrieveQueryKey(options)
  })

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiSchedulesPartialUpdateMutation = (
  options?: Partial<Options<ApiSchedulesPartialUpdateData>>
): UseMutationOptions<
  ApiSchedulesPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<ApiSchedulesPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiSchedulesPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<ApiSchedulesPartialUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiSchedulesPartialUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiSchedulesUpdateMutation = (
  options?: Partial<Options<ApiSchedulesUpdateData>>
): UseMutationOptions<
  ApiSchedulesUpdateResponse,
  AxiosError<DefaultError>,
  Options<ApiSchedulesUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiSchedulesUpdateResponse,
    AxiosError<DefaultError>,
    Options<ApiSchedulesUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiSchedulesUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiSkillsListQueryKey = (options?: Options<ApiSkillsListData>) =>
  createQueryKey('apiSkillsList', options)

export const apiSkillsListOptions = (options?: Options<ApiSkillsListData>) =>
  queryOptions<
    ApiSkillsListResponse,
    AxiosError<DefaultError>,
    ApiSkillsListResponse,
    ReturnType<typeof apiSkillsListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiSkillsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiSkillsListQueryKey(options)
  })

export const apiSkillsCreateMutation = (
  options?: Partial<Options<ApiSkillsCreateData>>
): UseMutationOptions<
  ApiSkillsCreateResponse,
  AxiosError<DefaultError>,
  Options<ApiSkillsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiSkillsCreateResponse,
    AxiosError<DefaultError>,
    Options<ApiSkillsCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiSkillsCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiSkillsDestroyMutation = (
  options?: Partial<Options<ApiSkillsDestroyData>>
): UseMutationOptions<
  ApiSkillsDestroyResponse,
  AxiosError<DefaultError>,
  Options<ApiSkillsDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiSkillsDestroyResponse,
    AxiosError<DefaultError>,
    Options<ApiSkillsDestroyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiSkillsDestroy({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiSkillsRetrieveQueryKey = (
  options: Options<ApiSkillsRetrieveData>
) => createQueryKey('apiSkillsRetrieve', options)

export const apiSkillsRetrieveOptions = (
  options: Options<ApiSkillsRetrieveData>
) =>
  queryOptions<
    ApiSkillsRetrieveResponse,
    AxiosError<DefaultError>,
    ApiSkillsRetrieveResponse,
    ReturnType<typeof apiSkillsRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiSkillsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiSkillsRetrieveQueryKey(options)
  })

export const apiSkillsPartialUpdateMutation = (
  options?: Partial<Options<ApiSkillsPartialUpdateData>>
): UseMutationOptions<
  ApiSkillsPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<ApiSkillsPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiSkillsPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<ApiSkillsPartialUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiSkillsPartialUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiSkillsUpdateMutation = (
  options?: Partial<Options<ApiSkillsUpdateData>>
): UseMutationOptions<
  ApiSkillsUpdateResponse,
  AxiosError<DefaultError>,
  Options<ApiSkillsUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiSkillsUpdateResponse,
    AxiosError<DefaultError>,
    Options<ApiSkillsUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiSkillsUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiTemplatesListQueryKey = (
  options?: Options<ApiTemplatesListData>
) => createQueryKey('apiTemplatesList', options)

export const apiTemplatesListOptions = (
  options?: Options<ApiTemplatesListData>
) =>
  queryOptions<
    ApiTemplatesListResponse,
    AxiosError<DefaultError>,
    ApiTemplatesListResponse,
    ReturnType<typeof apiTemplatesListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiTemplatesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiTemplatesListQueryKey(options)
  })

export const apiTemplatesRetrieveQueryKey = (
  options: Options<ApiTemplatesRetrieveData>
) => createQueryKey('apiTemplatesRetrieve', options)

export const apiTemplatesRetrieveOptions = (
  options: Options<ApiTemplatesRetrieveData>
) =>
  queryOptions<
    ApiTemplatesRetrieveResponse,
    AxiosError<DefaultError>,
    ApiTemplatesRetrieveResponse,
    ReturnType<typeof apiTemplatesRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiTemplatesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiTemplatesRetrieveQueryKey(options)
  })

export const apiTemplatesUseCreateMutation = (
  options?: Partial<Options<ApiTemplatesUseCreateData>>
): UseMutationOptions<
  unknown,
  AxiosError<DefaultError>,
  Options<ApiTemplatesUseCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<DefaultError>,
    Options<ApiTemplatesUseCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiTemplatesUseCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiThreadsListQueryKey = (options?: Options<ApiThreadsListData>) =>
  createQueryKey('apiThreadsList', options)

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiThreadsListOptions = (options?: Options<ApiThreadsListData>) =>
  queryOptions<
    ApiThreadsListResponse,
    AxiosError<DefaultError>,
    ApiThreadsListResponse,
    ReturnType<typeof apiThreadsListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiThreadsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiThreadsListQueryKey(options)
  })

export const apiThreadsListInfiniteQueryKey = (
  options?: Options<ApiThreadsListData>
): QueryKey<Options<ApiThreadsListData>> =>
  createQueryKey('apiThreadsList', options, true)

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiThreadsListInfiniteOptions = (
  options?: Options<ApiThreadsListData>
) =>
  infiniteQueryOptions<
    ApiThreadsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<ApiThreadsListResponse>,
    QueryKey<Options<ApiThreadsListData>>,
    | number
    | Pick<
        QueryKey<Options<ApiThreadsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ApiThreadsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await apiThreadsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })
        return data
      },
      queryKey: apiThreadsListInfiniteQueryKey(options)
    }
  )

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiThreadsDestroyMutation = (
  options?: Partial<Options<ApiThreadsDestroyData>>
): UseMutationOptions<
  ApiThreadsDestroyResponse,
  AxiosError<DefaultError>,
  Options<ApiThreadsDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiThreadsDestroyResponse,
    AxiosError<DefaultError>,
    Options<ApiThreadsDestroyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiThreadsDestroy({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiThreadsRetrieveQueryKey = (
  options: Options<ApiThreadsRetrieveData>
) => createQueryKey('apiThreadsRetrieve', options)

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiThreadsRetrieveOptions = (
  options: Options<ApiThreadsRetrieveData>
) =>
  queryOptions<
    ApiThreadsRetrieveResponse,
    AxiosError<DefaultError>,
    ApiThreadsRetrieveResponse,
    ReturnType<typeof apiThreadsRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiThreadsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiThreadsRetrieveQueryKey(options)
  })

/**
 * Manually compress the thread's model context (summarise + drop old
 * messages in the checkpointer). UI chat history is untouched. Rejected
 * while a run is in flight so we never mutate live state.
 */
export const apiThreadsCompactCreateMutation = (
  options?: Partial<Options<ApiThreadsCompactCreateData>>
): UseMutationOptions<
  ApiThreadsCompactCreateResponse,
  AxiosError<DefaultError>,
  Options<ApiThreadsCompactCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiThreadsCompactCreateResponse,
    AxiosError<DefaultError>,
    Options<ApiThreadsCompactCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiThreadsCompactCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiThreadsFilesListQueryKey = (
  options: Options<ApiThreadsFilesListData>
) => createQueryKey('apiThreadsFilesList', options)

/**
 * Every ready file in this thread — user uploads and agent files — newest first.
 */
export const apiThreadsFilesListOptions = (
  options: Options<ApiThreadsFilesListData>
) =>
  queryOptions<
    ApiThreadsFilesListResponse,
    AxiosError<DefaultError>,
    ApiThreadsFilesListResponse,
    ReturnType<typeof apiThreadsFilesListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiThreadsFilesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiThreadsFilesListQueryKey(options)
  })

export const apiThreadsMessagesRetrieveQueryKey = (
  options: Options<ApiThreadsMessagesRetrieveData>
) => createQueryKey('apiThreadsMessagesRetrieve', options)

/**
 * Replay a thread's user/assistant turns from persisted runs+steps.
 *
 * We don't pull from the LangGraph checkpointer (different Postgres
 * schema, async-only API). Instead we walk this thread's runs in
 * chronological order — `Run.input.message` is the user turn, and the
 * concatenated text steps for that run are the assistant turn.
 *
 * Also surfaces `active_run` so the FE can keep showing a typing
 * indicator (and poll for completion) when the user navigates back
 * into a thread whose stream is still being generated server-side.
 */
export const apiThreadsMessagesRetrieveOptions = (
  options: Options<ApiThreadsMessagesRetrieveData>
) =>
  queryOptions<
    ApiThreadsMessagesRetrieveResponse,
    AxiosError<DefaultError>,
    ApiThreadsMessagesRetrieveResponse,
    ReturnType<typeof apiThreadsMessagesRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiThreadsMessagesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiThreadsMessagesRetrieveQueryKey(options)
  })

/**
 * Rename a thread — narrowly scoped so callers can't change
 * `agent_id` or any of the annotated/derived fields.
 */
export const apiThreadsRenamePartialUpdateMutation = (
  options?: Partial<Options<ApiThreadsRenamePartialUpdateData>>
): UseMutationOptions<
  ApiThreadsRenamePartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<ApiThreadsRenamePartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiThreadsRenamePartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<ApiThreadsRenamePartialUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiThreadsRenamePartialUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiToolsRetrieveQueryKey = (
  options?: Options<ApiToolsRetrieveData>
) => createQueryKey('apiToolsRetrieve', options)

/**
 * `GET /api/tools/` — public catalog used by the agent builder.
 */
export const apiToolsRetrieveOptions = (
  options?: Options<ApiToolsRetrieveData>
) =>
  queryOptions<
    unknown,
    AxiosError<DefaultError>,
    unknown,
    ReturnType<typeof apiToolsRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiToolsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiToolsRetrieveQueryKey(options)
  })

export const apiUsageBreakdownRetrieveQueryKey = (
  options?: Options<ApiUsageBreakdownRetrieveData>
) => createQueryKey('apiUsageBreakdownRetrieve', options)

export const apiUsageBreakdownRetrieveOptions = (
  options?: Options<ApiUsageBreakdownRetrieveData>
) =>
  queryOptions<
    unknown,
    AxiosError<DefaultError>,
    unknown,
    ReturnType<typeof apiUsageBreakdownRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiUsageBreakdownRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiUsageBreakdownRetrieveQueryKey(options)
  })

export const apiUsagePlatformSummaryRetrieveQueryKey = (
  options?: Options<ApiUsagePlatformSummaryRetrieveData>
) => createQueryKey('apiUsagePlatformSummaryRetrieve', options)

/**
 * Cross-tenant usage roll-up: one row per account (org).
 */
export const apiUsagePlatformSummaryRetrieveOptions = (
  options?: Options<ApiUsagePlatformSummaryRetrieveData>
) =>
  queryOptions<
    unknown,
    AxiosError<DefaultError>,
    unknown,
    ReturnType<typeof apiUsagePlatformSummaryRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiUsagePlatformSummaryRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiUsagePlatformSummaryRetrieveQueryKey(options)
  })

export const apiUsageSummaryRetrieveQueryKey = (
  options?: Options<ApiUsageSummaryRetrieveData>
) => createQueryKey('apiUsageSummaryRetrieve', options)

export const apiUsageSummaryRetrieveOptions = (
  options?: Options<ApiUsageSummaryRetrieveData>
) =>
  queryOptions<
    unknown,
    AxiosError<DefaultError>,
    unknown,
    ReturnType<typeof apiUsageSummaryRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiUsageSummaryRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiUsageSummaryRetrieveQueryKey(options)
  })

export const apiVoiceConfigRetrieveQueryKey = (
  options?: Options<ApiVoiceConfigRetrieveData>
) => createQueryKey('apiVoiceConfigRetrieve', options)

/**
 * GET /api/voice/config/ — one call at chat mount.
 *
 * Answers "may this caller use voice, and how much is left", so no surface
 * ever has to discover a missing key or an exhausted allowance by getting an
 * error from a button the user already pressed.
 */
export const apiVoiceConfigRetrieveOptions = (
  options?: Options<ApiVoiceConfigRetrieveData>
) =>
  queryOptions<
    unknown,
    AxiosError<DefaultError>,
    unknown,
    ReturnType<typeof apiVoiceConfigRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiVoiceConfigRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiVoiceConfigRetrieveQueryKey(options)
  })

/**
 * POST /api/voice/stt/ — transcribe one utterance.
 *
 * The transcript is returned to the caller, NOT sent to the agent. It lands
 * in the composer so the user can correct it before pressing send, which
 * keeps `POST /api/chat/` the single chat entry point and means a
 * mis-transcription never silently becomes an agent action.
 */
export const apiVoiceSttCreateMutation = (
  options?: Partial<Options<ApiVoiceSttCreateData>>
): UseMutationOptions<
  unknown,
  AxiosError<DefaultError>,
  Options<ApiVoiceSttCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<DefaultError>,
    Options<ApiVoiceSttCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiVoiceSttCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * POST /api/voice/tts/ — synthesise one chunk.
 *
 * One short request per sentence-sized chunk, never one stream per answer.
 * squad-api runs gunicorn `gthread` (4 workers x 8 threads = 32 request slots
 * in production) and a streaming response holds a thread for its whole
 * lifetime; every active chat already holds one. A second long-lived stream
 * per conversation would halve effective capacity per pod.
 */
export const apiVoiceTtsCreateMutation = (
  options?: Partial<Options<ApiVoiceTtsCreateData>>
): UseMutationOptions<
  ApiVoiceTtsCreateResponse,
  AxiosError<DefaultError>,
  Options<ApiVoiceTtsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiVoiceTtsCreateResponse,
    AxiosError<DefaultError>,
    Options<ApiVoiceTtsCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiVoiceTtsCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiVoiceVoicesRetrieveQueryKey = (
  options?: Options<ApiVoiceVoicesRetrieveData>
) => createQueryKey('apiVoiceVoicesRetrieve', options)

/**
 * GET /api/voice/voices/ — the vendor catalog for the agent-builder picker.
 *
 * Cached under one global key: the catalog belongs to our single platform
 * account, so it is the same list for every tenant.
 */
export const apiVoiceVoicesRetrieveOptions = (
  options?: Options<ApiVoiceVoicesRetrieveData>
) =>
  queryOptions<
    unknown,
    AxiosError<DefaultError>,
    unknown,
    ReturnType<typeof apiVoiceVoicesRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiVoiceVoicesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiVoiceVoicesRetrieveQueryKey(options)
  })

/**
 * POST /api/widget/<public_key>/chat/ — anonymous SSE chat.
 *
 * Creates a WIDGET run, dispatches it headless (worker owns execution, like a
 * webhook), then tails the RunSteps as SSE (like `ChatStreamView`) so the
 * visitor sees the answer stream. If the agent pauses for a tool approval the
 * tail emits `paused` and the widget shows a graceful fallback — approval
 * cards are never exposed to anonymous visitors.
 */
export const apiWidgetChatCreateMutation = (
  options?: Partial<Options<ApiWidgetChatCreateData>>
): UseMutationOptions<
  unknown,
  AxiosError<DefaultError>,
  Options<ApiWidgetChatCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<DefaultError>,
    Options<ApiWidgetChatCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiWidgetChatCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiWidgetConfigRetrieveQueryKey = (
  options: Options<ApiWidgetConfigRetrieveData>
) => createQueryKey('apiWidgetConfigRetrieve', options)

/**
 * GET /api/widget/<public_key>/config/ — display config for the widget UI.
 */
export const apiWidgetConfigRetrieveOptions = (
  options: Options<ApiWidgetConfigRetrieveData>
) =>
  queryOptions<
    unknown,
    AxiosError<DefaultError>,
    unknown,
    ReturnType<typeof apiWidgetConfigRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiWidgetConfigRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiWidgetConfigRetrieveQueryKey(options)
  })

export const apiWidgetMessagesRetrieveQueryKey = (
  options: Options<ApiWidgetMessagesRetrieveData>
) => createQueryKey('apiWidgetMessagesRetrieve', options)

/**
 * GET /api/widget/<public_key>/messages/?visitor_id= — history replay.
 */
export const apiWidgetMessagesRetrieveOptions = (
  options: Options<ApiWidgetMessagesRetrieveData>
) =>
  queryOptions<
    unknown,
    AxiosError<DefaultError>,
    unknown,
    ReturnType<typeof apiWidgetMessagesRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiWidgetMessagesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiWidgetMessagesRetrieveQueryKey(options)
  })

export const apiWidgetOperatorMessagesRetrieveQueryKey = (
  options: Options<ApiWidgetOperatorMessagesRetrieveData>
) => createQueryKey('apiWidgetOperatorMessagesRetrieve', options)

/**
 * GET /api/widget/<public_key>/operator-messages/?visitor_id=&since= — a manager's replies.
 *
 * Separate from the history replay, and for one reason: an open page polls this every few
 * seconds, and the replay rebuilds the whole conversation out of runs and steps. This is one
 * indexed query over one small table.
 */
export const apiWidgetOperatorMessagesRetrieveOptions = (
  options: Options<ApiWidgetOperatorMessagesRetrieveData>
) =>
  queryOptions<
    unknown,
    AxiosError<DefaultError>,
    unknown,
    ReturnType<typeof apiWidgetOperatorMessagesRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiWidgetOperatorMessagesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiWidgetOperatorMessagesRetrieveQueryKey(options)
  })

/**
 * POST /api/widget/<public_key>/resume/ — anonymous visitor answers a
 * pending `ask_user` question.
 *
 * Deliberately narrow: this is the ONLY approval type ever exposed to an
 * anonymous widget visitor (`WidgetChatView`'s docstring — write/destructive
 * tool approvals stay hidden). Two checks enforce that on every request:
 * the approval's thread must be THIS visitor's own thread (can't resume
 * someone else's paused run), and its payload must satisfy
 * `_is_ask_user_payload` — `kind="ask_user"` or the legacy
 * `type="ask_user_question"` (can't drive a write-tool gate through this
 * path).
 */
export const apiWidgetResumeCreateMutation = (
  options?: Partial<Options<ApiWidgetResumeCreateData>>
): UseMutationOptions<
  unknown,
  AxiosError<DefaultError>,
  Options<ApiWidgetResumeCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<DefaultError>,
    Options<ApiWidgetResumeCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiWidgetResumeCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * POST /api/widget/<public_key>/voice/stt/ — anonymous transcription.
 *
 * Gated by its OWN switch on top of `voice_enabled`. An owner may reasonably
 * want the agent to speak to visitors without accepting audio uploads from
 * them, and the disclosure obligation for recording a stranger's voice is not
 * the same as for playing them a sentence.
 */
export const apiWidgetVoiceSttCreateMutation = (
  options?: Partial<Options<ApiWidgetVoiceSttCreateData>>
): UseMutationOptions<
  unknown,
  AxiosError<DefaultError>,
  Options<ApiWidgetVoiceSttCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<DefaultError>,
    Options<ApiWidgetVoiceSttCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiWidgetVoiceSttCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * POST /api/widget/<public_key>/voice/tts/ — anonymous synthesis.
 */
export const apiWidgetVoiceTtsCreateMutation = (
  options?: Partial<Options<ApiWidgetVoiceTtsCreateData>>
): UseMutationOptions<
  ApiWidgetVoiceTtsCreateResponse,
  AxiosError<DefaultError>,
  Options<ApiWidgetVoiceTtsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiWidgetVoiceTtsCreateResponse,
    AxiosError<DefaultError>,
    Options<ApiWidgetVoiceTtsCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiWidgetVoiceTtsCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiWidgetsListQueryKey = (options?: Options<ApiWidgetsListData>) =>
  createQueryKey('apiWidgetsList', options)

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiWidgetsListOptions = (options?: Options<ApiWidgetsListData>) =>
  queryOptions<
    ApiWidgetsListResponse,
    AxiosError<DefaultError>,
    ApiWidgetsListResponse,
    ReturnType<typeof apiWidgetsListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiWidgetsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiWidgetsListQueryKey(options)
  })

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiWidgetsCreateMutation = (
  options?: Partial<Options<ApiWidgetsCreateData>>
): UseMutationOptions<
  ApiWidgetsCreateResponse,
  AxiosError<DefaultError>,
  Options<ApiWidgetsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiWidgetsCreateResponse,
    AxiosError<DefaultError>,
    Options<ApiWidgetsCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiWidgetsCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiWidgetsDestroyMutation = (
  options?: Partial<Options<ApiWidgetsDestroyData>>
): UseMutationOptions<
  ApiWidgetsDestroyResponse,
  AxiosError<DefaultError>,
  Options<ApiWidgetsDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiWidgetsDestroyResponse,
    AxiosError<DefaultError>,
    Options<ApiWidgetsDestroyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiWidgetsDestroy({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const apiWidgetsRetrieveQueryKey = (
  options: Options<ApiWidgetsRetrieveData>
) => createQueryKey('apiWidgetsRetrieve', options)

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiWidgetsRetrieveOptions = (
  options: Options<ApiWidgetsRetrieveData>
) =>
  queryOptions<
    ApiWidgetsRetrieveResponse,
    AxiosError<DefaultError>,
    ApiWidgetsRetrieveResponse,
    ReturnType<typeof apiWidgetsRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiWidgetsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: apiWidgetsRetrieveQueryKey(options)
  })

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiWidgetsPartialUpdateMutation = (
  options?: Partial<Options<ApiWidgetsPartialUpdateData>>
): UseMutationOptions<
  ApiWidgetsPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<ApiWidgetsPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiWidgetsPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<ApiWidgetsPartialUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiWidgetsPartialUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiWidgetsUpdateMutation = (
  options?: Partial<Options<ApiWidgetsUpdateData>>
): UseMutationOptions<
  ApiWidgetsUpdateResponse,
  AxiosError<DefaultError>,
  Options<ApiWidgetsUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiWidgetsUpdateResponse,
    AxiosError<DefaultError>,
    Options<ApiWidgetsUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiWidgetsUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiWidgetsRotateKeyCreateMutation = (
  options?: Partial<Options<ApiWidgetsRotateKeyCreateData>>
): UseMutationOptions<
  ApiWidgetsRotateKeyCreateResponse,
  AxiosError<DefaultError>,
  Options<ApiWidgetsRotateKeyCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiWidgetsRotateKeyCreateResponse,
    AxiosError<DefaultError>,
    Options<ApiWidgetsRotateKeyCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiWidgetsRotateKeyCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const mcpToolsRetrieveQueryKey = (
  options?: Options<McpToolsRetrieveData>
) => createQueryKey('mcpToolsRetrieve', options)

/**
 * `GET /mcp/tools/` — the tool descriptors.
 *
 * Authorization filtering happens *inside* each tool when invoked, so the
 * descriptor list is the same for any authenticated user.
 */
export const mcpToolsRetrieveOptions = (
  options?: Options<McpToolsRetrieveData>
) =>
  queryOptions<
    unknown,
    AxiosError<DefaultError>,
    unknown,
    ReturnType<typeof mcpToolsRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await mcpToolsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: mcpToolsRetrieveQueryKey(options)
  })

/**
 * `POST /mcp/tools/<name>/call/` — invoke a tool as the authenticated user.
 *
 * Body: `{"args": {...}}` (or empty). Response mirrors MCP:
 * - success: `{"result": <dict>}`
 * - error:   `{"error": {"code": <str>, "message": <str>}}`
 */
export const mcpToolsCallCreateMutation = (
  options?: Partial<Options<McpToolsCallCreateData>>
): UseMutationOptions<
  unknown,
  AxiosError<DefaultError>,
  Options<McpToolsCallCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<DefaultError>,
    Options<McpToolsCallCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await mcpToolsCallCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}
